// Card.js
import React, { useEffect, useState, useRef, useContext } from 'react';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { Card as MuiCard, CardContent, Typography, CardHeader, Box, Grid, Divider } from '@mui/material';
import { numberWithCommas, formatarDataHora, validaCpfCnpj, CartaoCreditoTipo, identificacaoUsuarioLogado, identificacaoRazaoSocialUsuarioLogado, identificacaoNomeUsuarioLogado, identificaoEnderecoEntrega } from '../../utils';
import ImpressaoIcon from '../../assets/img/impressora.svg';
import CloseIcon from '../../assets/img/close.svg';
import LogoNafil from '../../assets/img/NAFIL_logo.svg';
import LogoN from '../../assets/img/NAFIL_logoCurto.svg';
import TextField from '@mui/material/TextField';
import NavBarTop from '../NavBar_Top/NavBar_Top';
import Button from '@mui/material/Button';
import { MyContext } from '../../context/MyContext';
import Avatar from '@mui/material/Avatar';
import { ReactToPrint, useReactToPrint } from 'react-to-print';
import QRCodeStyling from "qr-code-styling";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginaCardNotasFaturadasReciboPagamentos from '../CardNotasFaturadasRecibosPagamentos/CardNotasFaturadasRecibosPagamentos';
import api from '../../services/api';
import { useLocation, useHistory } from 'react-router-dom';
import { BrowserView, MobileView } from 'react-device-detect';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import PagamentoIcon from '../../assets/img/pagamento.svg';
import Stack from '@mui/material/Stack';
import BagIcon from '../../assets/img/bag.svg';
import Question from '../../../src/assets/img/question.svg';
import cartoes_selecaoIcon from '../../assets/img/cartoes_selecao.svg';
import cartoes_selecaoIconDisabled from '../../assets/img/cartoes_selecao_disabled.svg';
import boletoIcon from '../../assets/img/boleto.svg';
import boletoIconDisabled from '../../assets/img/boleto_disabled.svg';
import pixIcon from '../../assets/img/pix.svg';
import pixIconDisabled from '../../assets/img/pix_disabled.svg';
import cartoes_AMEX from '../../assets/img/cartoes_amex.svg';
import cartoes_ELO from '../../assets/img/cartoes_elo.svg';
import cartoes_DINERS from '../../assets/img/cartoes_diners.svg';
import cartoes_VISA from '../../assets/img/cartoes_visa.svg';
import cartoes_MASTERCARD from '../../assets/img/cartoes_mastercard.svg';
import cartoes_HIPERCARD from '../../assets/img/cartoes_hipercard.svg';
import cartoes_HIPER from '../../assets/img/cartoes_hiper.svg';
import cartoes_CABAL from '../../assets/img/cartoes_cabal.svg';
import cartoes_CVV from '../../assets/img/cartoes_cvv.svg';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import CircularProgress from '@mui/material/CircularProgress';
import Link from '@mui/material/Link';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputMask from 'react-input-mask';
import { textAlign } from '@mui/system';

const Card = (props, venda) => {
    const { showModalMeuPagamentoFaturado, setShowModalMeuPagamentoFaturado } = useContext(MyContext);
    const { destinoPagina, setDetinoPagina } = useContext(MyContext);
    const { linkPreVenda, setLinkPreVenda } = useContext(MyContext);
    const { linkPago, setLinkPago } = useContext(MyContext);
    const [urlQRCode, setUrlQRCode] = useState("");
    const qrCodeInstance = useRef(null);
    const [processoNumero, setProcessoNumero] = useState("");
    const [processoData, setProcessoData] = useState("");
    const [colunas, setColunas] = useState([[], [], []]);  // Array para armazenar as colunas
    const [satonImpressaoProcessoId, setSatonImpressaoProcessoId] = useState(0);
    const [satonImpressaoProcessoIdLoja, setSatonImpressaoProcessoIdLoja] = useState(0);
    const [dadosConteudoParaImpressao, setDadosConteudoParaImpressao] = useState([]);
    const [satonOriginal, setSatonOriginal] = useState([]);
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [linkPagamento, setLinkPagamento] = useState("");
    const [vendaEfetuada, setVendaEfetuada] = useState(null);
    const [criarLinkPagamento, setCriarLinkPagamento] = useState(false);
    const [botaoClicado, setBotaoClicado] = useState("");
    const [phoneNumber, setPhoneNumber] = useState('');
    const [showModalMeuTelefone, setShowModalMeuTelefone] = useState(false);
    const [retornoAPI, setRetornoAPI] = useState(null);
    const { meuFormaPagamentoTipo, setMeuFormaPagamentoTipo } = useContext(MyContext); // Tipo de Pagamento 1 - PIX / 2 - BOLETO / 3 - CARTÃO CRÉDITO ou DÉBITO
    const [pagamentoNumeroMaximoParcelas, setPagamentoNumeroMaximoParcelas] = useState({});
    const [pagamentoNumeroParcelas, setPagamentoNumeroParcelas] = useState(0);
    const [pagamentoNumeroParcelasError, setPagamentoNumeroParcelasError] = useState("");
    const [pagamentoValorParcelas, setPagamentoValorParcelas] = useState([]);
    const [_userId, set_userId] = useState(0);
    const [_userIdLoja, set_userIdLoja] = useState(0);
    const [_preVendaId, set_preVendaId] = useState(0);
    const [_preVendaIdLoja, set_preVendaIdLoja] = useState(0);
    const [_processoId, set_processoId] = useState(0);
    const [_processoIdLoja, set_processoIdLoja] = useState(0);
    const [_expiraEm, set_expiraEm] = useState(null);
    const [_nomeFullRazaoSocialLogado, set_nomeFullRazaoSocialLogado] = useState(null);
    const [atualizar, setAtualizar] = useState(false);    
    const [_dadosPedido, set_dadosPedido] = useState(null);
    const [cpf_cnpjError, setCpf_cnpjError] = useState("");
    const [vencimentoError, setVencimentoError] = useState("");
    const [cartaoSelecionado, setCartaoSelecionado] = useState("cartoes_CVV");
    const [cartaoTipoCartao, setCartaoTipoCartao] = useState(0);
    const [cartaoSolicitarCPF_CNPJ, setCartaoSolicitarCPF_CNPJ] = useState(true);
    const [cartaoDigitadoNumero, setCartaoDigitadoNumero] = useState("");
    const [cartaoNumeroError, setCartaoNumeroError] = useState("");
    const [cartaoDigitadoNome, setCartaoDigitadoNome] = useState("");
    const [cartaoNomeError, setCartaoNomeError] = useState("");
    const [cartaoDigitadoValidade, setCartaoDigitadoValidade] = useState("");
    const [cartaoDigitadoCVV, setCartaoDigitadoCVV] = useState("");
    const [cartaoDigitadoCPFCNPJ, setCartaoDigitadoCCPFCNPJ] = useState("");
    const [pagamentoOpcaoSelecionada, setPagamentoOpcaoSelecionada] = useState("");

    const { showModalMeuPagamentoFaturadoReciboDePagamento, setShowModalMeuPagamentoFaturadoReciboDePagamento } = useContext(MyContext);
    const { meuCarrinho, setMeuCarrinho } = useContext(MyContext);
    const { carrinhoCounter, setCarrinhoCounter } = useContext(MyContext);
    const [totalProdutos, setTotalProdutos] = useState(0.00);
    const [totalFrete, setTotalFrete] = useState(0.00);
    const [totalDescontos, setTotalDescontos] = useState(0.00);
    const [totalCreditos, setTotalCreditos] = useState(0.00);
    const [totalGeral, setTotalGeral] = useState(0.00);
    const [atualizarPagina, setAtualizarPagina] = useState(false);

    const [confirmouCancelamento, setConfirmouCancelamento] = useState(false);    // usado para indicar se faltar item poderá ser cancelado
    const [openQuestion, setOpenQuestion] = useState(false);
    const [confirmouCancelamentoError, setConfirmouCancelamentoError] = useState("");
    const [fechandoPedido, setFechandoPedido] = useState(false);
    const [sumirBotao, setSumirBotao] = useState(false);
    const [falhouPagamentos, setFalhouPagamentos] = useState("");
    const [retornoApi, setRetornoApi] = useState({});
    const [usuarioLogado, setUsuarioLogado] = useState("");  // Armazena Criptografado o Id e Loja do Cliente
    const { showModalMeuPedido, setShowModalMeuPedido } = useContext(MyContext);
    const {linkPagamentoMensagem, setLinkPagamentoMensagem} = useContext(MyContext); // = useState(null);
    const [tipoFrete, setTipoFrete] = useState(-1);
    const { meusCreditosSelecionados, setMeusCreditosSelecionados } = useContext(MyContext);  // Créditos Selecionados Para Pagamentos
    const [cepEntregaSelecionado, setCepEntregaSelecionado] = useState({});
    const [cepDigitado, setCepDigitado] = useState("");
    const [descontoPagamentoAVista, setDescontoPagamentoAVista] = useState({});
    const [tipoFreteDados, setTipoFreteDados] = useState({});
    const [hasCep, setHasCep] = useState(false);
    const [freteError, setFreteError] = useState("");
    const [fretes, setFretes] = useState([]);
    const { meuCreditoDetalhes, setMeuCreditoDetalhes } = useContext(MyContext); // Armazena os Dados dos Créditos a Serem utilizados no Ato de Pagamento
    const [nomeFullRazaoSocialLogado, setNomeFullRazaoSocialLogado] = useState("");
    const {nomeUsuarioLogado, setNomeUsuarioLogado} = useContext(MyContext); // Armazena Criptografado o Nome do Usuário Logado
    const [pedidosWebClass, setPedidosWebClass] = useState({
        preVendas: {},
        // preVendasItensComMarcaClass: [],
        preVendasItens: [],
        especie: [],
        creditos: [],
        cartaoNumero: "",
        cartaoValidade: "",
        cartaoCVV: "",
        cartaoNome: "",
        idModeloTransporte: -1,
        pixCopiaCola: "",
        usuarioLogado: "",
        nomeUsuarioLogado: ""
    });

    console.log("VENDAX ", props?.venda);

    const componentRef = useRef();
    const history = useHistory();
    let vendaAtual = null;  // Variável para rastrear a venda atual
    let vendasAgrupadas = [];  // Armazena as vendas agrupadas por id_venda
    const linhasPorColuna = 8; // Definindo limite de linhas por coluna
    let colunaAtual = -1;  // Coluna atual (0 = esquerda, 1 = centro, 2 = direita) -1 Porque Será Somado 1 ao inciar
    let linhasPreenchidas = 0;  // Contador de linhas preenchidas
    let itensNaPagina = 0;  //
    // let limiteLinhasPorPagina = Math.ceil( (props.props == 'undefined' ? props.satonParcial.length / 3 : props.props.satonParcial.length / 3 ));  // Notas Inteiras ou Contador de linhas preenchidas
    let vendasAgrupadasLinhasPorColuna = [];  // Armazena as vendas agrupadas por id_venda
    const qrCodeRef = useRef(null);
    const dataToPrintRef = useRef();
    let _temPIXpendente = null;

    const sucessoMensagem = (mensagem) => toast.success(mensagem,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    const toastFaltouSelecionarModoDeFrete = (message) => toast.error(message,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 5000 });

    const toastFalhaPagamentoCartao = (message) => toast.error(message,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 5000 });

    const toastConfirmadoPagamentoCartao = (message) => toast.success(message,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    const toastMarcarItensParaImpressao = () => toast.error("Selecione Algum Item Para Impressão!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    const toastMensagemError = (message) => toast.error(message,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    const toastErroApiNaoResponde = () => toast.error("Ops, Alguma Coisa Errada com Nosso Servidor!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const modalStyleReciboPagamentos = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '500px',
        width: '90%', // Garante responsividade e centralização mesmo em telas menores
        bgcolor: 'background.paper',
        boxShadow: 24,
        // p: 4, // Padding interno do modal (opcional)
        overflow: 'auto',
    }

    useEffect(() => {

        if (props == null){

           // setVendaEfetuada(props?.venda);
        }


        if (props != null && props?.venda != null){
            setVendaEfetuada(props?.venda);
        }
        if (props != null && props?.props != null) {
            setLinkPagamento(props?.props);
            PegarDescontoAVista();
        }

        console.log("Linha 208 ", linkPreVenda ,urlQRCode);
        if (linkPreVenda != null && linkPreVenda?.especie != null && linkPreVenda?.especie.filter((xp) => xp.nband == 17 && xp.pix_recebido == null).length > 0){
            set_dadosPedido(linkPreVenda);
            setUrlQRCode(linkPreVenda?.pixCopiaCola);
            setSumirBotao(true);
            console.log("Linha -208 ", linkPreVenda , linkPreVenda?.pixCopiaCola);
            //setUrlQRCode(linkPreVenda)
        }
        if (linkPreVenda != null && linkPreVenda?.especie != null && linkPreVenda?.especie.filter((xp) => xp.nband == 17 && xp.pix_recebido != null).length > 0){
            set_dadosPedido(linkPreVenda);
            setUrlQRCode(null);
            setSumirBotao(true);
            setLinkPago(true);
            setLinkPagamentoMensagem({ cabecalho: "Link de Pagamento Já Concluído", corpo: "Pagamento já foi finalizado, agora é só aguardar o recebimento." });
            console.log("Linha -208 ", linkPreVenda , linkPreVenda?.pixCopiaCola);
            //setUrlQRCode(linkPreVenda)
        }

        qrCodeInstance.current = new QRCodeStyling({
            width: 200,
            height: 200,
            data: urlQRCode,
            image:
                LogoN,
            dotsOptions: {
                color: "#000000",
                type: "rounded"
            },
            imageOptions: {
                crossOrigin: "anonymous",
                margin: 5
            }
        });

        qrCodeInstance.current.append(qrCodeRef.current);
    }, []);

    useEffect(() => {
        verificarPropriedades();

        console.log("Linha 231 ", urlQRCode, props);
        console.log("Linha 232 ", props?.venda);
        setVendaEfetuada(props?.venda);

        if (linkPagamento.hasOwnProperty("aVista")) {
            let _linkPagamento = linkPagamento?.aVista.split('/');
    
            // _userId = linkPagamento[0].split("=")[1]; // idCliente
            // _userIdloja = linkPagamento[1].split("=")[1]; // idClienteLoja
    
            // _preVendaId = linkPagamento[2].split("=")[1]; // idPreVenda
            // _preVendaIdloja = linkPagamento[3].split("=")[1]; // idPreVendaLoja
    
            // _processoId = linkPagamento[4].split("=")[1]; // idProcesso
            // _processoIdLoja = linkPagamento[5].split("=")[1]; // idProcessoLoja
            
            // _valorRestante = linkPagamento[6].split("=")[1]; // valor
    
            // _nomeFullRazaoSocialLogado = linkPagamento[7].split("=")[1]; // Razão Social    
            set_expiraEm(_linkPagamento[8].split("=")[1]); // expiraEm    
        }
        // setPagamentoValorParcelas(DividirParcelamentosCartoes());
    }, [linkPagamento]);

    useEffect(() => {
        Recalculos();
        console.log("Linha 238 ", urlQRCode, props);

        //setPagamentoValorParcelas(DividirParcelamentosCartoes());
    }, [meuFormaPagamentoTipo]);

    useEffect(() => {
        console.log("voltando ");

        //setPagamentoValorParcelas(DividirParcelamentosCartoes());
        setPagamentoValorParcelas(DividirParcelamentosCartoes());

    }, [atualizarPagina]);

    const handlePrint = useReactToPrint({
        content: () => dataToPrintRef.current
    });

    const handleChangeComboParcelamentos = (event) => {
        const {
            target: { value },
        } = event;
        let _numeroParcelasSelecionada = Number(event?.target?.value.substr(0, event?.target?.value.indexOf("x")) ?? '0');
        setPagamentoNumeroParcelas(_numeroParcelasSelecionada);
        setPagamentoOpcaoSelecionada(
            // On autofill we get a stringified value.
            //typeof value === 'string' ? value.split(',') : value,
            typeof value === 'string' ? value : value,
        );
        setPagamentoNumeroParcelasError("");
    };

    const modalStyleQuestions = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '3px solid #008000',
        boxShadow: 24,
        p: 4,
    };

    function PegarDescontoAVista() {
        api.get('Prazos/DescontoAVistaPrazoPagamento').then((response) => {
            setDescontoPagamentoAVista(response?.data);
            setAtualizarPagina(true);
        }).catch((e) => {
            if (e == "Error: Network Error") {
                toastErroApiNaoResponde();
                setFreteError("Ops, Nosso Servidor Não Respondeu...");
                return null;
            }
            setFreteError(e);
            setDescontoPagamentoAVista(0.00);
            setAtualizarPagina(true);
            return null;
        });
    }

    function Recalculos() {
        console.log("PegarDescontoAVista", descontoPagamentoAVista);
        console.log("meuFormaPagamentoTipo", meuFormaPagamentoTipo);
        console.log("meuVenda", vendaEfetuada);

        if (vendaEfetuada != null) {

            let __totalProdutos = vendaEfetuada?.preVendas.total_produtos;
            let __totalFrete = vendaEfetuada?.preVendas.total_frete;
            let __totalDescontos = vendaEfetuada?.preVendas.total_descontos;
            let __totalCreditos = vendaEfetuada?.preVendas.total_creditos;

            // Somente PIX Gera Desconto
            if (meuFormaPagamentoTipo > 2) {
                __totalDescontos = 0.00;
            }
            else {
                let _percentualDescontoAVista = (descontoPagamentoAVista == null || Object.keys(descontoPagamentoAVista).length === 0 ? 0.00 : 1 + (descontoPagamentoAVista.juros / 100));
                __totalDescontos = (meuFormaPagamentoTipo <= 2 && __totalProdutos > descontoPagamentoAVista?.minimo ? __totalProdutos - (__totalProdutos * _percentualDescontoAVista) : 0.00);
            }

            setTotalCreditos(__totalCreditos);
            setTotalFrete(__totalFrete);
            setTotalProdutos(__totalProdutos);
            setTotalDescontos(__totalDescontos);

            setTotalGeral(Number((__totalProdutos + __totalFrete - __totalDescontos - __totalCreditos).toFixed(2)));

            console.log("REC GERAL", Number((__totalProdutos + __totalFrete - __totalDescontos - __totalCreditos).toFixed(2)));
        }

        // var ultimoCEPDigitado = window.getCookie('nafil_ultimo_cep');
        // // if (descontoPagamentoAVista == null || Object.keys(descontoPagamentoAVista).length === 0)
        // // {
        // //     PegarDescontoAVista();            
        // // }
        // let __totalProdutos = 0.00;
        // let __totalFrete = 0.00;
        // let __totalDescontos = 0.00;
        // let __totalCreditos = 0.00;

        // if (meusCreditosSelecionados != null && meusCreditosSelecionados.length > 0) {
        //     __totalCreditos = meusCreditosSelecionados.reduce((totalCreditos, item) => {
        //         return totalCreditos + item.valor;
        //     }, 0);
        //     setTotalCreditos(__totalCreditos);
        // }
        // else {
        //     __totalCreditos = 0.00;
        //     setTotalCreditos(__totalCreditos);
        // }

        // if (cepEntregaSelecionado != null && Object.keys(cepEntregaSelecionado).length > 0 && tipoFrete != -1) {
        //     __totalFrete = cepEntregaSelecionado.price;
        //     setTotalFrete(__totalFrete);
        // }
        // else {
        //     __totalFrete = 0.00;
        //     setTotalFrete(__totalFrete);
        // }

        // if (ultimoCEPDigitado) {
        //     setCepDigitado(ultimoCEPDigitado);
        //     var antes = document.getElementById("cepFrete");
        //     if (antes) {
        //         if (antes?.value?.length == 0) {
        //             antes.value = ultimoCEPDigitado;
        //         }
        //     }
        // }

        // __totalProdutos = meuCarrinho.reduce((totalProdutos, item) => {
        //     return totalProdutos + (item.quantidade * item.preco);
        // }, 0);

        // setTotalProdutos(__totalProdutos);

        // if (meuFormaPagamentoTipo == -1) {
        //     if (meuFormaPagamentoTipo <= 1) {
        //         TipoPagamento(1);
        //     } else {
        //         TipoPagamento(meuFormaPagamentoTipo);
        //     }
        // }

        // let _percentualDescontoAVista = (descontoPagamentoAVista == null || Object.keys(descontoPagamentoAVista).length === 0 ? 0.00 : 1 + (descontoPagamentoAVista.juros / 100));
        // __totalDescontos = (meuFormaPagamentoTipo <= 2 && __totalProdutos > descontoPagamentoAVista?.minimo ? __totalProdutos - (__totalProdutos * _percentualDescontoAVista) : 0.00);

        // console.log("DescxA ", meuFormaPagamentoTipo);
        // console.log("DescxB ", descontoPagamentoAVista);
        // console.log("DescxC ", descontoPagamentoAVista.juros);
        // console.log("DescxD ", descontoPagamentoAVista?.minimo);
        // console.log("DescxE ", __totalProdutos);
        // console.log("DescxF ", _percentualDescontoAVista);


        // setTotalDescontos(__totalDescontos);
        // setTotalGeral(Number((__totalProdutos + __totalFrete - __totalDescontos - __totalCreditos).toFixed(2)));
        // setPagamentoValorParcelas(DividirParcelamentosCartoes());

        // var elem = document.getElementById('cepFrete');
        // if (typeof elem !== 'undefined' && elem !== null) {
        //     if (cepDigitado != document.getElementById('cepFrete').value) {
        //         PesquisarCEP(cepDigitado, null);  // Efetua Cotação dos Fretes Pelo Melhor Envio
        //     }
        // }
    }

    function handleCheckBoxConcordo(e) {
        setConfirmouCancelamento(e?.target?.checked);
        setConfirmouCancelamentoError("");
    }

    const handleCompartilharLinkPagamento = async () => {
        setBotaoClicado("Compartilhar");

        if (linkPagamento == null || linkPagamento == "") {
            console.log("ROG 36", linkPagamento);
            setCriarLinkPagamento(true);
            // } else {
            //     handleEnviarMensagemWhatsApp(linkPagamento);  // LINK DE PAGAMENTO                                
        }
        else {

            console.log("ROG 39", linkPagamento);
            handleEnviarWhatsAppWeb();  // Web
        }
    };

    const handleCloseModalQuestion = () => {
        setOpenQuestion(false);
    }

    const handleEnviarWhatsAppWeb = () => {
        // Removendo caracteres especiais da máscara para obter apenas números


        console.log("ROG 33", linkPagamento);

        const numeroDestinatario = phoneNumber.replace(/\D/g, '');

        if (numeroDestinatario == null || numeroDestinatario.length < 7) {
            toastMensagemError("Número do Telefone Está Inválido");
        }

        console.log("ROG 34", numeroDestinatario);

        const textoMensagem = encodeURIComponent("Olá! Esse é o Copia e Cola do PIX para realizar o pagamento à NAFIL Auto Peças:\n" + (urlQRCode ?? ""));

        console.log("ROG 35", textoMensagem);

        //const linkMensagem = linkPagamento.replace(/ /g, "+"); // Substitua Espaços Por + (" ", "+") no seu link          

        //console.log("ROG 36", linkMensagem);

        console.log("ROG 37", `https://web.whatsapp.com/send?phone=55${numeroDestinatario}&text=${textoMensagem}`);

        const urlWhatsApp = `https://web.whatsapp.com/send?phone=55${numeroDestinatario}&text=${textoMensagem}`;
        window.open(urlWhatsApp, '_blank');
    };

    const handleEnviarMensagemWhatsApp = (parametros) => {
        // const isLocalhost = window.location.hostname === 'localhost';
        // const baseUrl = isLocalhost ? 'http://localhost:3000' : 'https://whats.nafil.com.br';
        //VOLTAR setLinkPagamento(`${baseUrl}/compartilhado?pagamento=${parametros.encryptedText}`);

        console.log("LINKOUUUABC ", linkPagamento);

        if (window.navigator.maxTouchPoints > 0) // 0 = DESKTOP --- 1 = CELULARES MOBILES 
        {
            console.log("LINKOUUUU ", linkPagamento);

            if (navigator.share) {
                navigator
                    .share({
                        title: 'NAFIL Efetuar Pagamento',
                        text: linkPagamento,
                        // url: linkPagamento, // Coloque aqui o link de pagamento
                    })
                    .then(() => console.log('Compartilhamento concluído com sucesso'))
                    .catch((error) => console.error('Erro ao compartilhar:', error));
            } else {
                console.log("LINKOUUUXABC ", linkPagamento);
                // console.log("WPPPPA 2");
                // try {
                //    setShowModalMeuTelefone(true);
                // WhatsAppShare(linkPagamento);
                // // alert('Compartilhamento Não Suportado Neste Dispositivo.');
                // // if (window.innerWidth >= 1024) { // Verifica se é um desktop com base na largura da janela
                // const numeroDestinatario = "5524988027944"; // Número no formato internacional
                // const textoMensagem = encodeURIComponent("Olá! Acesse o link abaixo para realizar o pagamento:");
                // const linkMensagem = linkPagamento; // Substitua pelo seu link
                // const urlWhatsApp = `https://web.whatsapp.com/send?phone=${numeroDestinatario}&text=${textoMensagem}%0A${linkMensagem}`;
                // window.open(urlWhatsApp, '_blank'); // Abre o WhatsApp Web em uma nova aba
                // }
                // } catch (errorWeb) {
                //     console.log("WPPPPA 3", errorWeb);
                //     alert('Compartilhamento Disponível Apenas em Dispositivos Móveis ou WhatsApp Web!');
                // }
            }
        }
        else {
            console.log("WPPPPA 3 ABC");
            setShowModalMeuTelefone(true);
        }
    };

    const handleLinkPagamento = async (data) => {
        setBotaoClicado("Copiar Link Pagamento");
        if (linkPagamento == "") {

            console.log("ROG 22 ", linkPagamento);
            setCriarLinkPagamento(true);

            //            let _retornoLink = await handleCriarLinkPagamento();

            // console.log("LIXO ", linkPagamento);

            // if (linkPagamento != null && linkPagamento != ""){
            //     navigator.clipboard.writeText(linkPagamento);
            // }
        }
        // else {
        //     navigator.clipboard.writeText(data.encryptedText);
        // }
    };

    const handleInputChange = (event) => {
        setPhoneNumber(event.target.value);
    };

    const [preVendasItem, setPreVendasItem] = useState([]);
    const [especieItem, setEspecieItem] = useState({
        especie_id: 0,
        especie_loja: 998,  // 999
        venda_id: 0,
        venda_loja: 998,  // 999
        data: "1997-01-01T00:00:00",
        tipo: 0,
        valor: 0.00,
        vezes: 0,
        usuario: 0,
        caixa: 0,
        retorno: null,
        codctf: null,
        respdll: null,
        operadora_cnpj: null,
        cartao: "",
        bandeira: "",
        codautor: "",
        retautor: "",
        nsu: "",
        nsuautor: "",
        aprovacao: "",
        van: "",
        operadora: "",
        autorizadora: "",
        transacao: "1997-01-01 00:00:00",
        modo: "",
        resposta: "",
        nband: 0,
        disk: 1,
        finalizado: 0,
        tipo_integracao: 0,
        tid: "",
        presencial: 0,
        pix_txid: null,
        pix_validade: null,
        pix_recebido: null,
        pix_location: null,
        ordem: 0
    });

    function PesquisarCPF_CNPJ(value, event) {
        // Teclas Aceitas
        if (event != null && event.key == "Backspace") {
            if (value.length == 12) {
                value = value.substr(0, 11);
                return;
            }
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                if (value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length != 11 || value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length != 14) {
                    return;
                }
            }
        }
        // CNPJ
        if (value != null && value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length >= 14) {
            var objDigitados = document.getElementById("cartaoCPF");
            var digitados = objDigitados.value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");
            if (digitados != null) {
                objDigitados.value = digitados.substr(0, 2) + "." + digitados.substr(2, 3) + "." + digitados.substr(5, 3) + "/" + digitados.substr(8, 4) + "-" + digitados.substr(12, 2);
                setCpf_cnpjError("");
            }
        }
        // CPF
        else {
            if (value != null && value.indexOf('.') == -1 && value.replaceAll("-", "").length == 3 || value != null && value.replaceAll("-", "").length == 7) {
                var antes = document.getElementById("cartaoCPF");
                antes.value = value + ".";
                setCpf_cnpjError("");
            }
            if (value != null && value.replaceAll("-", "").length == 11 && value.indexOf('-') == -1) {
                var antes = document.getElementById("cartaoCPF");
                antes.value = value + "-";
                setCpf_cnpjError("");
            }
            if (value != null && value.replaceAll("-", "").length < 5 && value.indexOf('-') != -1) {
                var antes = document.getElementById("cepFrete");
                antes.value = value.replace("-", "");
                setCpf_cnpjError("");
            }
            if (value != null && value.indexOf('.') == -1 && value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length == 11) {
                var objDigitados = document.getElementById("cartaoCPF");
                var digitados = objDigitados.value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");
                if (digitados != null) {
                    objDigitados.value = digitados.substr(0, 3) + "." + digitados.substr(3, 3) + "." + digitados.substr(6, 3) + "-" + digitados.substr(9, 2);
                    setCpf_cnpjError("");
                }
            }
        }
        // Finalizado Digitação Vou Ferificar os Valores Digitados
        if (value != null) {
            if (validaCpfCnpj(value) == false) {
                if (value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length == 11) {
                    setCpf_cnpjError("CPF Inválido");
                }
                if (value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length == 14) {
                    setCpf_cnpjError("CNPJ Inválido");
                }
            }
            else {
                setCpf_cnpjError("");
            }
        }
    }

    function VerificarDigitacaoCartoes() {
        if (cartaoDigitadoNumero.replaceAll(" ", "").replace(/[^0-9]/, '').length < 14) {
            setCartaoNumeroError("Número do Cartão Inválido");            
            return false;
        } else {
            setCartaoNumeroError("");
        }
        if (cartaoDigitadoNome.replaceAll(" ", "").length < 8) {
            setCartaoNomeError("Nome do Portador do Cartão Inválido");
            return false;
        } else {
            setCartaoNumeroError("");
        }
        if (cartaoDigitadoValidade.replaceAll(" ", "").replace(/[^0-9]/, '').length < 4) {
            setVencimentoError("Validade do Cartão Inválida");
            return false;
        } else {
            setVencimentoError("");
        }
        if (cartaoDigitadoValidade.indexOf('/') == -1) {
            setVencimentoError("Ano de Vencimento Inválido");
        }
        if (cartaoDigitadoValidade.split('/')[0] <= '00' || cartaoDigitadoValidade.split('/')[0] >= '13') {
            setVencimentoError("Mês de Vencimento Inválido");
            return;
        }
        else {
            setVencimentoError("");
        }
        var anoAtual = new Date().getFullYear().toString();
        if (cartaoDigitadoValidade.split('/')[1] <= '00' || anoAtual != null && cartaoDigitadoValidade.split('/')[1] < anoAtual.substring(2, 4)) {
            setVencimentoError("Ano de Vencimento Inválido");
            return;
        } else {
            setVencimentoError("");
        }
        if (cartaoDigitadoCVV.replaceAll(" ", "").replace(/[^0-9]/, '').length < 3 || cartaoDigitadoCVV.replaceAll(" ", "").replace(/[^0-9]/, '').length > 4) {
            setVencimentoError("CVV do Cartão Inválido");
            return false;
        } else {
            setVencimentoError("");
        }
        if (pagamentoNumeroParcelas <= 0 || pagamentoNumeroParcelasError > 12) {
            setPagamentoNumeroParcelasError("Selecione o Número de Parcelas Desejado");
            return false;
        }
        else {
            setPagamentoNumeroParcelasError("");
        }
        if (confirmouCancelamento == false) {
            setConfirmouCancelamentoError("Será Necessário Marcar 'Concordo...' Pois as Lojas Físicas Estão Vendendo Simultâneamente");
            return false;
        } else {
            setConfirmouCancelamentoError("");
        }
        return true;
    }

    function DividirParcelamentosCartoes() {
        var _valorDasParcelas = [];
        // if (pagamentoNumeroMaximoParcelas != null && pagamentoNumeroMaximoParcelas?.prestacao != null) {

        console.log("Geral totalProdutos ", totalProdutos);
        console.log("Geral totalDescontos ", totalDescontos);
        console.log("pagamentoNumeroMaximoParcelas?.prestacao", pagamentoNumeroMaximoParcelas?.prestacao);


        var _valorTotal = (totalProdutos + totalFrete - totalDescontos - totalCreditos);
        for (let i = 1; i <= Number(pagamentoNumeroMaximoParcelas?.prestacao ?? 1); i++) {
            _valorDasParcelas.push(i + ' x ' + (_valorTotal / i).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + ' sem juros');
        }
        return (_valorDasParcelas);
        // }
    }

    async function VerificarModeloFreteSelecionado(_tipoFrete) {
        await api.get(`Fretes/ModeloTransporte/${_tipoFrete}`).then(res => {
            setTipoFreteDados(res.data);
            return (res.data);

        }).catch(err => {
            setFreteError(err);
            return false;
        });
    }

    function TestarCVV(value, event) {
        // Teclas Aceitas
        if (event != null && event.key == "Backspace") {
            setVencimentoError("");
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                setVencimentoError("");
                return;
            }
        }
        if (value != null) {
            var objDigitados = document.getElementById("cartaoCVV");
            var digitados = objDigitados.value;
            if (digitados != null) {
                // Testar CVV
                if (objDigitados.value != null && objDigitados.value.length < 3) {
                    setVencimentoError("CVV - Código de Segurança Inválido");
                    return;
                }
                else {
                    setVencimentoError("");
                    setCartaoDigitadoCVV(digitados);
                }
            }
        }
    }

    function TestarNomeCartao(value, event) {
        // Teclas Aceitas
        if (event != null && event.key == "Backspace") {
            setCartaoNomeError("");
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                setCartaoNomeError("");
                return;
            }
        }
        if (value != null) {
            var objDigitados = document.getElementById("cartaoNome");
            var digitados = objDigitados.value;
            if (digitados != null) {
                // Testar CVV
                if (objDigitados.value != null && objDigitados.value.length < 2) {
                    setCartaoNomeError("Nome do Portador Inválido");
                    return;
                }
                else {
                    setCartaoNomeError("");
                    setCartaoDigitadoNome(digitados);
                }
            }
        }
    }

    function TestarNumeroCartaoCredito(value, event) {
        if (event != null && event.key == "Backspace") {
            setCartaoNumeroError("");
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                if (value.replaceAll(".", "").length != 4) {
                    setCartaoNumeroError("");
                    return;
                }
            }
        }
        if (value != null) {
            var objDigitados = document.getElementById("cartaoNumero");
            var digitados = objDigitados.value.replaceAll(" ", "").replace(/[^0-9]/, '');
            if (digitados != null) { // && digitados.length > 4) {
                var _bloco01 = digitados.substr(0, 4);
                var _bloco02 = (digitados.length > 4 ? digitados.substr(4, 4) : "");
                var _bloco03 = (digitados.length > 8 ? digitados.substr(8, 4) : "");
                var _bloco04 = (digitados.length > 12 ? digitados.substr(12, 4) : "");;
                objDigitados.value = _bloco01 + (_bloco02 != "" ? " " + _bloco02 : "") + (_bloco03 != "" ? " " + _bloco03 : "") + (_bloco04 != "" ? " " + _bloco04 : "");
                setCartaoNumeroError("");
            }
            if (digitados != null && digitados.length >= 15) {
                setCartaoSelecionado(CartaoCreditoTipo(digitados));
                setCartaoDigitadoNumero(digitados);
            }
        }
    }

    function TestarValidadeCartaoCredito(value, event) {
        // Teclas Aceitas
        if (event != null && event.key == "Backspace") {
            setVencimentoError("");
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                if (value.replaceAll("/", "").replaceAll("-", "").replaceAll(" ", "").length != 4) {
                    setVencimentoError("");
                    return;
                }
            }
        }
        if (value != null) {
            var objDigitados = document.getElementById("cartaoValidade");
            var digitados = objDigitados.value.replaceAll("/", "").replaceAll("-", "");
            if (digitados != null) {
                objDigitados.value = (digitados.length >= 2 ? digitados.substr(0, 2) + "/" : digitados) + (digitados.length > 2 ? digitados.substr(2, digitados.length - 2) : "");

                // Testar Mês
                if (objDigitados.value != null && objDigitados.value.length >= 2) {
                    if (objDigitados.value.substr(0, 2) <= '00' || objDigitados.value.substr(0, 2) >= '13') {
                        setVencimentoError("Mês de Vencimento Inválido");
                        return;
                    }
                    else {
                        setVencimentoError("");
                    }
                }

                // Testar Ano
                if (objDigitados.value != null && objDigitados.value.length == 5) {
                    var anoAtual = new Date().getFullYear().toString();
                    if (objDigitados.value.substr(3, 2) <= '00' || anoAtual != null && objDigitados.value.substr(3, 2) < anoAtual.substring(2, 4)) {
                        setVencimentoError("Ano de Vencimento Inválido");
                        return;
                    } else {
                        setVencimentoError("");
                    }
                }
                setCartaoDigitadoValidade(objDigitados.value);
            }
        }
    }

    function PesquisarCEP(value, event) {
        if (value == null || value == "") {
            document.getElementById("cepFrete").value = "";
            setCepDigitado("");
            setHasCep(false);
            window.setCookie('nafil_ultimo_cep', '', 365);
            return;
        }
        setHasCep(true);
        if (event != null && event.key == "Backspace") {
            if (value.replace("-", "").length == 6) {
                value = value.substr(0, 5);
                return;
            }
            return;
        }
        else {
            if (event != null && event.key != "Delete" && event.key != "Tab" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                return;
            }
        }
        if (value != null && value.indexOf('-') == -1 && value.replaceAll("-", "").length == 5) {
            var antes = document.getElementById("cepFrete");
            antes.value = value + "-";
            if (event != null) {
                setFretes([]);
                setFreteError("");
            }
        }
        if (value != null && value.replaceAll("-", "").length < 5 && value.indexOf('-') != -1) {
            var antes = document.getElementById("cepFrete");
            antes.value = value.replace("-", "");
            if (event != null) {
                setFretes([]);
                setFreteError("");
            }
        }
        if (value != null && value.replaceAll("-", "").length == 8) {
            let _cepSemMascara = value.replaceAll("-", "");
            let _cepComMascara = _cepSemMascara.substr(0, 5) + "-" + _cepSemMascara.substr(5, 3);
            // CEP 27281-510 = 9
            if (cepDigitado != _cepComMascara) {
                setCepDigitado(_cepComMascara);
                setFreteError("Aguarde...");
            }

            // Montar Caixas Para o Cálculo do Envio 
            let _caixaMontada = { cep: "", quantidadeCaixas: 1, listaItensNaCaixa: [] };

            var itensNaCaixa = [];
            meuCarrinho.map((e) => {
                let _itm = {
                    // cep: _cepSemMascara, 
                    codigo: e.codigo,
                    quantidade: e.quantidade,
                    preco: e.preco,
                    desconto: 0.00, // ARRUMAR
                    peso: e.peso,
                    largura: e.largura,
                    comprimento: e.comprimento,
                    altura: e.altura
                };

                itensNaCaixa.push(_itm);
            });
            _caixaMontada = { cep: _cepSemMascara, quantidadeCaixas: 1, listaItensNaCaixa: itensNaCaixa };

            api.post(`Fretes/CotacaoMelhorEnvio`, _caixaMontada).then((response) => {
                // Comtém"ERROR" na Resposta da API     
                if (response?.data?.retornoME == null) {
                    setFretes([]);
                    setFreteError(response?.data?.error.toString());
                    toastMensagemError(response?.data?.error.toString());
                    // toastMensagemError(JSON.parse(response?.data?.autorizacao)["error"] );
                    // setFreteError(JSON.parse(response?.data?.autorizacao)["error"].toString());
                }
                else {
                    setCepEntregaSelecionado({});
                    setTipoFrete(-1);
                    setFretes(response?.data?.retornoME);
                    setFreteError("");
                    window.setCookie('nafil_ultimo_cep', _cepComMascara, 365);
                }
            }).catch((e) => {
                if (e == "Error: Network Error") {
                    toastErroApiNaoResponde();
                    setFreteError("Ops, Nosso Servidor Não Respondeu...");
                    return null;
                }
                setFreteError("CEP Não Foi Localizado!");
            })
        }
        if (value != null && value.length != 9) {
            if (event != null) {
                setFretes([]);
                setFreteError("");
            }
        }
    }

    const handleOpenModal = () => {
        // setOpen(true);
        setShowModalMeuPedido(true);
    }

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 48 * 4.5 + 8,
                width: 250,
            },
        },
    };

    const salvarDadosPagamento = async (e) => {
        // var __clienteID = 0;
        // var __clienteIDLoja = 0;
        // var __nomeUsuario = "";
        // if (usuarioLogado == null || usuarioLogado.indexOf("_") == -1 || usuarioLogado == "") {
        //     toastMensagemError("Será Necessário Efetuar Login!");
        //     return;
        // }
        // else {
        //     __clienteID = usuarioLogado.split('_')[0];
        //     __clienteIDLoja = usuarioLogado.split('_')[1];
        // }

        // // Verifica Se o Meio de Transporte Foi Selecionado
        // if (tipoFrete == -1) {
        //     toastFaltouSelecionarModoDeFrete("Selecione o Tipo de Frete Desejado");
        //     return;
        // }    
        Recalculos();

        if (meuFormaPagamentoTipo == -1) {
            toastMensagemError("Selecione o Tipo de Pagamento Desejado");
            return;
        }
        setFechandoPedido(true);
        setSumirBotao(true);

        // Verifica Meio de Pagamento e Analisa se Está Todos Dados Preenchidos
        var listaItens = [];
        var listaEspecie = [];
        var listaPreVendasItensComMarcaClass = [];
        let _preVendasItem = preVendasItem;
        let _especie = especieItem;

        // tipo_integracao tabela 'especie'
        // 1 - POS
        // 2 - TEF
        // 3 - ON-LINE

        ////// 1 - PIX
        if (meuFormaPagamentoTipo == 1) {
            _especie.especie_id = 0;
            _especie.especie_loja = 998;  // 999
            _especie.venda_id = _preVendaId;
            _especie.venda_loja = _preVendaIdLoja; // 999
            _especie.data = '1997-01-01T00:00:00';
            _especie.tipo = 'PIX';
            _especie.valor = totalGeral ?? 0.00;
            _especie.vezes = 1;
            _especie.usuario = 0;
            _especie.caixa = 0;
            _especie.retorno = '';
            _especie.codctf = '';
            _especie.respdll = '';
            _especie.operadora_cnpj = '';
            _especie.cartao = '';
            _especie.bandeira = '';
            _especie.codautor = '';
            _especie.retautor = '';
            _especie.nsu = '';
            _especie.nsuautor = '';
            _especie.aprovacao = '';
            _especie.van = '';
            _especie.operadora = '';
            _especie.autorizadora = '';
            _especie.transacao = '1997-01-01T00:00:00';
            _especie.modo = '';
            _especie.resposta = 'AGUARDANDO';
            _especie.nband = 17;  // 17 - 'PIX PAGAMENTO INSTANTÂNEO' tabela 'tipos_pagamentos'
            _especie.disk = 1;
            _especie.finalizado = 0;
            _especie.tipo_integracao = 2;
            _especie.presencial = 0;
            _especie.ordem = 1;
            _especie.processo_id = 0;
            _especie.processo_id_loja = 0;

            listaEspecie.push(_especie);
        }
        else if (meuFormaPagamentoTipo == 2) { // BOLETOS BANCÁRIOS

            console.log("BOLETOS AAAA");

            _especie.especie_id = 0;
            _especie.especie_loja = 998; // 999
            _especie.venda_id = _preVendaId;
            _especie.venda_loja = _preVendaIdLoja; // 999
            _especie.data = '1997-01-01T00:00:00';
            _especie.tipo = 'BOLETO BANCÁRIO';
            _especie.valor = totalGeral ?? 0.00;
            _especie.vezes = pagamentoNumeroParcelas ?? 1;
            _especie.usuario = 0;
            _especie.caixa = 0;
            _especie.retorno = '';
            _especie.codctf = '';
            _especie.respdll = '';
            _especie.operadora_cnpj = '';
            _especie.cartao = '';
            _especie.bandeira = '';
            _especie.codautor = '';
            _especie.retautor = '';
            _especie.nsu = '';
            _especie.nsuautor = '';
            _especie.aprovacao = '';
            _especie.van = '';
            _especie.operadora = '';
            _especie.autorizadora = '';
            _especie.transacao = '1997-01-01T00:00:00';
            _especie.modo = '';
            _especie.resposta = '';
            _especie.nband = 15;  // BOLETO BANCÁRIO
            _especie.disk = 1;
            _especie.finalizado = 0;
            _especie.tipo_integracao = 2;
            _especie.presencial = 0;
            _especie.ordem = 1;
            _especie.processo_id = 0;
            _especie.processo_id_loja = 0;
            // _especie.pixTxid
            listaEspecie.push(_especie);
        }
        else if (meuFormaPagamentoTipo == 3) { // CARTÕES DE DÉBITO OU CRÉDITO
            if (VerificarDigitacaoCartoes() == false) { 
                setSumirBotao(false);
                setFechandoPedido(false);
                return;
            }
            _especie.especie_id = 0;
            _especie.especie_loja = 998; // 999
            _especie.venda_id = _preVendaId;
            _especie.venda_loja = _preVendaIdLoja; // 999
            _especie.data = '1997-01-01T00:00:00';
            _especie.tipo = ((3 + cartaoTipoCartao) == 4 ? 'CARTÃO DE DÉBITO' : 'CARTÃO DE CRÉDITO');
            _especie.valor = totalGeral ?? 0.00;
            _especie.vezes = pagamentoNumeroParcelas ?? 1;
            _especie.usuario = 0;
            _especie.caixa = 0;
            _especie.retorno = '';
            _especie.codctf = '';
            _especie.respdll = '';
            _especie.operadora_cnpj = '01425787000104'; // REDE CARD CNPJ OPERADORA
            _especie.cartao = '';
            _especie.bandeira = '';
            _especie.codautor = '';
            _especie.retautor = '';
            _especie.nsu = '';
            _especie.nsuautor = '';
            _especie.aprovacao = '';
            _especie.van = '';
            _especie.operadora = '';
            _especie.autorizadora = '';
            _especie.transacao = '1997-01-01T00:00:00';
            _especie.modo = '';
            _especie.resposta = '';
            _especie.nband = (3 + cartaoTipoCartao);  // 3 ou 4  - cartaoTipoCartao Seleciona Crédito 3 ou Débito 4
            _especie.disk = 1;
            _especie.finalizado = 0;
            _especie.tipo_integracao = 2;
            _especie.presencial = 0;
            _especie.ordem = 1;
            _especie.processo_id = 0;
            _especie.processo_id_loja = 0;

            // _especie.pixTxid
            listaEspecie.push(_especie);
        };

        // let _modeloFreteTransportadora = await VerificarModeloFreteSelecionado(tipoFrete);

        let PreVendas = {
            ids_prevendas: 0,
            ids_prevendas_loja: 998, // 999
            filial: 998,  // 999 
            tipo: (meuFormaPagamentoTipo <= 2 ? 1 : 2),
            vendedor: 0,
            data: "1997-01-01T00:00:00",
            agendada: "1997-01-01T00:00:00",
            micro: "SITE",
            conferido_user: null, // 0
            conferido_data: null, // "0001-01-01T00:00:00",
            automatico: 0,
            total_produtos: totalProdutos,
            total_descontos: totalDescontos,
            total_frete: totalFrete,
            total_geral: totalGeral,
            caixa: 0,
            disk: 1,
            cliente_id: 0,
            cliente_loja: 0,
            cliente_cpf_cnpj: "",
            cliente_ie_rg: "",
            cliente_razao_social: "",
            cliente_fantasia: "",
            cliente_contato: "",
            cliente_telefone: "",
            endereco: "",
            numero: "",
            complemento: "",
            referencia: "",
            bairro: "",
            id_uf: 0,
            id_cidade: 0,
            id_pais: 0,
            ext_uf: "",
            ext_cidade: "",
            cep: "",
            observacoes: "",
            situacao: 1,
            cancelada_user: null,
            cancelada_data: null,
            grupo: null,
            embalagem: null,
            lacre: 0,
            motoboy: 0,
            finalizado: 0,
            transporte_id: 0,
            transporte_loja: 0,
            transporte_rastreamento: "",
            faturado: 0, // ARRUMAR
            forma_pagamento: 0, // ARRUMAR
            operador: 0,
            cliente_filial: 0, // ARRUMAR
            f6: 0,
            transporte_modelo: "",
            transporte_data_saida: null,
            cliente_email: null,
            peso: 0.00,
            prazo_frete: 0,
            boleto_expira: null,
            web_app: 1,
            total_creditos: 0
        };

        let _PreVendasItensComMarcaClass = {
            PreVendasItens: preVendasItem,
        };

        meuCarrinho.forEach(function (meuCarrinho) {
            console.log("IN -> ", meuCarrinho);
            listaPreVendasItensComMarcaClass.push()
        });

        // console.log("OUT -> ", listaPreVendasItensComMarcaClass);

        const dados = pedidosWebClass;

        // PreVendas.prazo_frete = Number(fretes.filter((f) => f.id == tipoFrete)[0]?.delivery_time);
        dados.preVendas = PreVendas;
        dados.preVendasItens = meuCarrinho;

        // console.log("BOLETOS BABY ", meuCarrinho);
        // console.log("BOLETOS BBBB ", listaEspecie);

        dados.especie = listaEspecie;

        // if (Object.keys(meuCreditoDetalhes).length === 0) {
        //     dados.creditos = null;

        // } else {
        //     dados.creditos = meuCreditoDetalhes;
        // }

        // dados.idModeloTransporte = tipoFrete;  // ESCOLHE O MODELO DO FRETE DESEJADO
        // dados.usuarioLogado = nomeFullRazaoSocialLogado.split(' ').slice(0, 2).join(' ').substring(0, 30).trim();
        // dados.nomeUsuarioLogado = nomeUsuarioLogado;
        dados.preVendas.total_creditos = totalCreditos;
        dados.preVendas.total_descontos = totalDescontos;
        dados.preVendas.total_frete = totalFrete;
        dados.preVendas.total_produtos = totalProdutos;
        dados.preVendas.total_geral = totalGeral;

        // CARTAO DE CRÉDITO / DÉBITO
        if (meuFormaPagamentoTipo == 3) {
            dados.cartaoNumero = "MTz547kaAyyRP9xooknjJIbsewYSchF" + Buffer.from(cartaoDigitadoNumero).toString('base64');
            dados.cartaoValidade = "EvTIWqQ57d698BcmnIO65743aXkJ8511Dai" + Buffer.from(cartaoDigitadoValidade).toString('base64');
            dados.cartaoCVV = "GhiOoB1657pR8dSiexW25711Tr16unMS" + Buffer.from(cartaoDigitadoCVV).toString('base64');
            dados.cartaoNome = "cHJ32pdmF0ZSBzdGF0aWAMgcXmVhZG9ubSQHkgSHR0cESAXNsaWVudCBfQ2xpZ324W50ID0gbmV3I25OpEh0dHBDbGllSKlBvbnQoKTs" + Buffer.from(cartaoDigitadoNome.toUpperCase()).toString('base64');
        }
        setPedidosWebClass(dados);

        console.log('pedex ', dados);

        // const cookies = new Cookies();
        // const xsrfToken = cookies.get('XSRF-TOKEN');
        const xsrfToken = window.getCookie('XSRF-TOKEN');

        // console.log("XSRF-TOKEN", xsrfToken);
        // let CarambaClass = { 
        //     IdsPrevendas : "2223"
        // }
        // setPreVendaState({});
        // _prevenda.IdsPrevendas = 998; 
        // setPreVendaState(_prevenda);        
        // console.log("listaItens", listaItens);       

        console.log("JUUUUUUUUU ", pedidosWebClass);

        let salvando = await api.post('Pedidos/SalvarEspecie', pedidosWebClass).then(res => {
            console.log("JUUUUUUUUU 01:", res);
            if (res.status == 200 && res?.data != null && res?.data?.message == null) {
                // SUCESSO NO PAGAMENTO      
                console.log("JUUUUUUUUU 02:", res);
                if (meuFormaPagamentoTipo == 1) {
                    set_dadosPedido(res?.data);
                    setSumirBotao(true);
                    setFechandoPedido(false);
                    toastConfirmadoPagamentoCartao("PIX Criado com Sucesso");
                }
                if (meuFormaPagamentoTipo == 3) {
                    console.log("JUUUUUUUUU 03:", res);
                    set_dadosPedido(res?.data);
                    setFalhouPagamentos(res.data.cartaoRetornoCodigo + " - " + res.data.cartaoRetornoMessage);
                    toastConfirmadoPagamentoCartao(res.data.cartaoRetornoCodigo + " - " + res.data.cartaoRetornoMessage);
                }
                console.log("JUUUUUUUUU 04:", res);
                console.log("JUUUUUUUUU 05:", res?.data);
                setRetornoApi(res.data);

                console.log("JUUUUUUUUU 06:", res?.data.pixCopiaCola);

                if (meuFormaPagamentoTipo == 1) {
                    setUrlQRCode(res?.data.pixCopiaCola);
                }

                // handleOpenModal();
            }   // if (res.status == 200 && res?.data != null && res?.data?.message == null){          
            if (res.status == 200 && res?.data != null && res?.data?.message != null && res?.data?.message.length > 0) {
                // FALHA NO PAGAMENTO DEVIDO A AUTORIZAÇÃO NEGADA PELA API DA REDE
                setFalhouPagamentos(res.data.cartaoRetornoCodigo + " - " + res.data.cartaoRetornoMessage);
                toastFalhaPagamentoCartao(res.data.cartaoRetornoCodigo + " - " + res.data.cartaoRetornoMessage);
                setSumirBotao(true);
                setFechandoPedido(false);
            }
            console.log("SSSSSSS", res.data);
            return res.data;
        }).catch(err => {
            console.log("TTTTTTT", err);
            setFechandoPedido(false);
            setSumirBotao(false);
            setFalhouPagamentos(err.response.data.returnCode + " - " + err.response.data.returnMessage);
            toastFalhaPagamentoCartao(err.response.data.returnCode + " - " + err.response.data.returnMessage);
            return false;
        });
    }

    function TelaTipoDeCartaoCreditoOuDebito(modeloCartao) {
        // 0 - Cartão de Crédito / 1 -Cartão de Débito
        // 0 - Cartão de Crédito
        if (modeloCartao == 0) {
            setCartaoSolicitarCPF_CNPJ(true);
            setCartaoTipoCartao(0);
            setPagamentoNumeroParcelas(0);
            setPagamentoOpcaoSelecionada("");
            setPagamentoNumeroParcelasError("");
        }
        // 1 -Cartão de Débito
        else if (modeloCartao == 1) {
            setCartaoSolicitarCPF_CNPJ(false);
            setCartaoTipoCartao(1);
            setPagamentoNumeroParcelas(1);
            setPagamentoOpcaoSelecionada("");
            setPagamentoNumeroParcelasError("");
        }
    }

    const handleCloseModal = () => {
        if (destinoPagina != "") {
            // setDetinoPagina("home");
            history.push('/');
        }
        setShowModalMeuPagamentoFaturado(false);
    }

    const functionCopyToClipboard = async (e) => {

        console.log("LINKOOUB: ", urlQRCode, props );

        navigator.clipboard.writeText(urlQRCode);
        pixCopiadoSucesso("PIX Copiado com Sucesso A");
    }

    async function TipoPagamento(value) {
        if (value <= 2) {
            setPagamentoNumeroMaximoParcelas({ prestacao: 1 });
            setCartaoTipoCartao(0);
            TelaTipoDeCartaoCreditoOuDebito(0);
        } else {
            const response = await api.get('Prazos/' + totalGeral).then((response) => {
                setPagamentoNumeroMaximoParcelas(response?.data);
                setCartaoTipoCartao(0);
                TelaTipoDeCartaoCreditoOuDebito(0);
                // Recalculos();
                // setPagamentoValorParcelas(DividirParcelamentosCartoes());
            }).catch((e) => {
                console.log(e);
            })
        }
        if (meuFormaPagamentoTipo != value) {
            setMeuFormaPagamentoTipo(value); // Tipo de Pagamento 1 - PIX / 2 - BOLETO / 3 - CARTÃO CRÉDITO ou DÉBITO                        
            setAtualizarPagina(!atualizarPagina);
        }
    }


    function maskString(input, tamanho) {
        let count = 0; // Contador para rastrear caracteres não-espaço
        return input.replace(/(\S)/g, (char) => {
            if (count < 10) {
                count++; // Incrementa o contador para cada caractere não-espaço
                return char;
            } else {
                return "*";
            }
        });
    }

    const pixCopiadoSucesso = (nome) => toast.success("PIX Copiado com Sucesso F",
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 1500 });

    const adicionarObjetoNaColuna = (colunaIndex, objeto) => {
        setColunas((prevColunas) => {
            // Cria uma cópia das colunas anteriores para evitar mutação
            const novasColunas = [...prevColunas];
            // Adiciona o objeto à coluna correspondente
            novasColunas[colunaIndex] = [...novasColunas[colunaIndex], objeto];
            return novasColunas;
        });
    };

    const handleSendMensagemWhatsApp = (modelo) => {
        if (modelo == 1) { // BOTÃO COMPARTILHAR
            if (window.navigator.maxTouchPoints > 0) // DECIDE SE É: 0 = DESKTOP --- 1 = CELULARES MOBILES 
            {
                // ENVIA PELO APP
                if (navigator.share) {

                    console.log("LINKOUUUU G", linkPagamento);

                    navigator
                        .share({
                            title: 'NAFIL Link de Pagamento',
                            text: 'Olá! Acesse o link abaixo para realizar o pagamento:',
                            url: urlQRCode, // Coloque aqui o link de pagamento
                        })
                        .then(() => console.log('Compartilhamento concluído com sucesso'))
                        .catch((error) => console.error('Erro ao compartilhar:', error));
                } else {
                    alert('Compartilhamento Não Suportado Neste Dispositivo.');
                }
                console.log("LINKOUUUU C", modelo);
            }
            else { // DESKTOP

                console.log("LINKOUUUU D", showModalMeuTelefone);
                if (showModalMeuTelefone) {
                    toastMensagemError("Clique no Botão 'Enviar Mensagem'!")
                    return;
                }
                else {
                    setShowModalMeuTelefone(true);
                }
            }
        }



        console.log("LINKOUUUU A", modelo, showModalMeuTelefone);

        if (modelo == 1 && showModalMeuTelefone == false) {

            setShowModalMeuTelefone(true);
            // handleMudarEstadoModelo(true);

            console.log("LINKOUUUU B", modelo, showModalMeuTelefone);

            return;
        }



        console.log("LINKOUUUU E", linkPagamento);


        switch (modelo) {
            case 1: // WhatsApp APP
                console.log("LINKOUUUU F", linkPagamento);
                setShowModalMeuTelefone(false);
                // handleMudarEstadoModelo(false);
                break;

            case 2:  // WhatsAPP WEB
                console.log("LINKOUUUU H", linkPagamento);
                const numeroDestinatario = phoneNumber.replace(/\D/g, '');
                const textoMensagem = encodeURIComponent("Olá! Acesse o link abaixo para realizar o pagamento:\n" + urlQRCode);
                // const linkMensagem = linkPagamento.replace(/ /g, "+"); // Substitua Espaços Por + (" ", "+") no seu link          
                // console.log("ROG 34", linkMensagem);
                //const urlWhatsApp = `https://web.whatsapp.com/send?phone=55${numeroDestinatario}&text=${textoMensagem}%0A${linkMensagem}`;
                const urlWhatsApp = `https://web.whatsapp.com/send?phone=55${numeroDestinatario}&text=${textoMensagem}`;
                window.open(urlWhatsApp, '_blank');
                break;
            default:
            // code block
        }
    };

    const verificarPropriedades = async () => {

        if (linkPagamento != "") {
            if (linkPagamento.hasOwnProperty("aVista")) {

                console.log("Boi", linkPagamento.hasOwnProperty("aVista"));

                let lPagamento = linkPagamento?.aVista.split('/');

                set_userId(lPagamento[0].split("=")[1]); // idCliente
                set_userIdLoja(lPagamento[1].split("=")[1]); // idClienteLoja

                set_preVendaId(lPagamento[2].split("=")[1]); // idPreVenda
                set_preVendaIdLoja(lPagamento[3].split("=")[1]); // idPreVendaLoja

                set_processoId(lPagamento[4].split("=")[1]); // idProcesso
                set_processoIdLoja(lPagamento[5].split("=")[1]); // idProcessoLoja

                set_expiraEm(lPagamento[6].split("=")[1]); // expiraEm

                set_nomeFullRazaoSocialLogado(lPagamento[7].split("=")[1]); // Razão Social   
                let __userId = lPagamento[0].split("=")[1];
                let __userIdLoja = lPagamento[1].split("=")[1];
                let __preVendaId = lPagamento[2].split("=")[1];
                let __preVendaIdLoja = lPagamento[3].split("=")[1];
                let __totalGeral = lPagamento[6].split("=")[1];

                const refazerAtualizacao = async () => {
                    let dados = null;

                    
                    console.log("MIGUEL 341 ", totalGeral, props);
                    console.log("MIGUEL 3441 ", lPagamento);

                    if (__totalGeral <= 0){
                        return null;
                    }
                    try {                       

                        console.log("MIGUEL 344 ", `Pedidos/PIXVerificarPagamentoEfetuad/${__userId}/${__userIdLoja}/${__preVendaId}/${__preVendaIdLoja}/${__totalGeral}`);

                        // await api.get(`Pedidos/PIXVerificarPagamentoEfetuado/${__userId}/${__userIdLoja}/${__preVendaId}/${__preVendaIdLoja}/${__totalGeral}`)
                        await api.get(`Pedidos/PIXVerificarPagamentoEfetuado/${__userId}/${__userIdLoja}/${__preVendaId}/${__preVendaIdLoja}/${__totalGeral}`)
                            .then((response) => {

                                console.log("MIGUEL 345 ", response.data, vendaEfetuada?.preVendas?.total_geral);

                                // console.log("Box", response.data[0].preVendas.total_produtos);
                                // setRetornoAPI(response.data);

                                // setTotalProdutos(response.data[0].preVendas.total_produtos);
                                // setTotalFrete(response.data[0].preVendas.total_frete);
                                // setTotalCreditos(response.data[0].preVendas.total_creditos);
                                // setTotalGeral(response.data[0].preVendas.total_produtos + response.data[0].preVendas.total_frete - response.data[0].preVendas.total_creditos);

                                setTotalProdutos(vendaEfetuada?.preVendas?.total_produtos);
                                setTotalFrete(vendaEfetuada?.preVendas?.total_frete);
                                setTotalCreditos(vendaEfetuada?.preVendas?.total_creditos);
                                setTotalGeral(vendaEfetuada?.preVendas?.total_produtos + vendaEfetuada?.preVendas?.total_frete - vendaEfetuada?.preVendas?.total_creditos);

                            })
                            .catch((erro) => {
                                //setDadosConteudoParaImpressao(null);
                                toastMensagemError("FalhouAAA: " + erro.message)
                            });
                    } catch (e) {
                        // setDadosConteudoParaImpressao(null);
                        // toastMensagemError("Falha Geral: " + e.message)
                        return null;
                    };
                }
                refazerAtualizacao();
            }
        }
    };

    useEffect(() => {
        console.log("LINKOUUAA ", urlQRCode);

        if (urlQRCode != null && urlQRCode.length > 0) {
            const qrCode = new QRCodeStyling({
                width: 200,
                height: 200,
                data: urlQRCode,
                image:
                    LogoN,
                dotsOptions: {
                    color: "#000000",
                    type: "rounded"
                },
                imageOptions: {
                    crossOrigin: "anonymous",
                    margin: 5
                }
            });

            qrCode.append(qrCodeRef.current);
            qrCode.update({
                data: urlQRCode
            });
            // const intervalID = setInterval(myCallback, 2000, 'Parameter 1', 'Parameter 2');
            const intervalID = setInterval(verificarPagamentosPIX, 6000, 'Parameter 1', 'Parameter 2');
            // montarImpressao();
        }
    }, [urlQRCode]);


    async function verificarPagamentosPIX(a, b) {

        console.log("Linha 2282");

        if (_dadosPedido?.especie.filter((xp) => xp.nband == 17 && xp.pix_recebido == null).length > 0) { // 17
          _dadosPedido.especie.filter((xp) => xp.nband == 17 && xp.pix_recebido == null).map((xpag) => { // 17

            console.log("Linha 2283");
            console.log("PIPPPP ", `Pedidos/PIXVerificarPagamentoEfetuado/${xpag.venda_id}/${xpag.venda_loja}/${xpag.especie_id}/${xpag.especie_loja}/${xpag.valor}`);

            api.get(`Pedidos/PIXVerificarPagamentoEfetuado/${xpag.venda_id}/${xpag.venda_loja}/${xpag.especie_id}/${xpag.especie_loja}/${xpag.valor}`).then(res => {
              if (res.status == 200 && res?.data != null && res?.data?.message == null) {
                // SUCESSO NO RECEBIMENTO DO PIX
                sucessoMensagem("PIX Recebido com Sucesso!");
                xpag.pix_Recebido = res.data;
                setUrlQRCode('');
                setShowModalMeuPagamentoFaturado(false);
                return;
              }
            }).catch(err => {
                console.log("Linha 2284");

              return false;
            });
          })
        }
        console.log("Linha 2285", _dadosPedido);
        if (_dadosPedido?.especie.filter((xp) => xp.nband == 17 && xp.pix_recebido != null).length > 0) { // 17
            console.log("Linha 2286");
            console.log("PIPPPP2 ");
            sucessoMensagem("PIX Recebido com Sucesso!");            
            setUrlQRCode('');
        }
      }

    function montarFormasPagamentos() {
        return (
            <>
                <Stack direction="row" maxHeight={65}>
                    <img src={(meuFormaPagamentoTipo == 1 ? pixIcon : pixIconDisabled)} onClick={(e) => TipoPagamento(1)} style={{ height: '50px', maxHeight: '50px', marginTop: '8px', cursor: 'pointer' }} />
                    <img src={(meuFormaPagamentoTipo == 2 ? boletoIcon : boletoIconDisabled)} onClick={(e) => TipoPagamento(2)} style={{ height: '50px', maxHeight: '50px', marginLeft: '30px', marginTop: '8px', cursor: 'pointer' }} />
                    <img src={(meuFormaPagamentoTipo == 3 ? cartoes_selecaoIcon : cartoes_selecaoIconDisabled)} onClick={(e) => TipoPagamento(3)} sx={{ height: '45px', maxHeight: '45px' }} style={{ cursor: 'pointer', marginLeft: '30px' }} />
                </Stack>
            </>
        );
    };


    // const calcularTotalVenda = (vendaId) => {
    //     const itensFiltrados = props.props.satonParcial.filter(
    //         prod => (prod.id_venda + "-" + prod.id_venda_loja) === vendaId
    //     );

    //     // Atualiza a variável itensNaPagina com o número de itens filtrados
    //     itensNaPagina += itensFiltrados.length;

    //     // if (itensNaPagina > limiteLinhasPorPagina) {
    //     //     itensNaPagina = itensFiltrados.length;
    //     // }

    //     // Calcula o total com base nos itens filtrados
    //     return itensFiltrados.reduce((total, prod) => {
    //         const valorItem = prod.unitario * prod.quantidade;
    //         // Armazena o número do item na página (poderia ser feito após o reduce também)
    //         // vendasAgrupadasLinhasPorColuna.push(itensNaPagina);     
    //         if (prod.especie === 1) {
    //             return total + valorItem; // Não altera o valor
    //         } else {
    //             return total + (valorItem * -1); // Multiplica por -1
    //         }
    //     }, 0); // Inicializa o total com 0
    // };

    // if (meuFormaPagamentoTipo == -1) {
    //     setMeuFormaPagamentoTipo(1);
    // }

    console.log("retornoAPI[0].", retornoAPI);
    console.log("retornoAPI[1].", vendaEfetuada);
    console.log("retornoAPI[2].", linkPagamento);
    

    return (
        <>
            <BrowserView>
                <>
                    {(vendaEfetuada != null
                        ?

                        <MuiCard sx={{ bgcolor: '#F5F5F5', marginLeft: '130px', marginTop: '30px', marginRight: '130px', minHeight: '10px', marginBottom: '30px' }}>
                            <CardContent>

                                <Grid container marginTop={'30px'}>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2} container justifyContent="flex-end">
                                        <Typography sx={{ fontSize: "14px" }} style={{ color: 'black' }}>
                                            Link de Pagamento:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3} container justifyContent="flex-start">
                                        <Typography sx={{ fontSize: "16px", fontWeight: "bold", marginLeft: '20px' }} style={{ color: 'black', fontWeight: 'bold' }}>
                                            {(vendaEfetuada != null ? maskString(vendaEfetuada?.preVendas.cliente_razao_social, 10) : "")}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={1} container justifyContent="flex-end">
                                        <Typography variant='h16' style={{ color: 'black' }}>
                                            Valor R$:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={1} container justifyContent="flex-end">
                                        <Typography sx={{ fontSize: "16px", fontWeight: "bold", marginLeft: '20px' }} style={{ color: 'black' }}>
                                            {(vendaEfetuada != null ? numberWithCommas(vendaEfetuada?.preVendas.total_geral) : "")}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                    </Grid>


                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={2} container justifyContent="flex-end">
                                        <Typography sx={{ fontSize: "14px" }} style={{ color: 'black' }}>
                                            Pré-Venda:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={2} container justifyContent="flex-start">
                                        <Typography sx={{ fontSize: "16px", fontWeight: "bold", marginLeft: '20px' }} style={{ color: 'black', fontWeight: 'bold' }}>
                                            {_preVendaId + "-" + _preVendaIdLoja}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={1.3} container justifyContent="flex-end">
                                        <Typography variant='h16' style={{ color: 'black' }}>
                                            Expira em:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={2.7} container justifyContent="flex-start">
                                        <Typography sx={{ fontSize: "16px", fontWeight: "bold", marginLeft: '20px' }} style={{ color: 'black', fontWeight: 'bold' }}>
                                            {formatarDataHora(_expiraEm, 4)}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={2} container justifyContent="flex-start">
                                    </Grid>

                                    <Grid item xs={12} container justifyContent="center" alignItems="center">
                                        <Typography sx={{ fontSize: "12px", marginTop: '25px' }} style={{ color: 'grey' }}>
                                            Selecione Abaixo o Meio de Pagamento Desejado Para Continuar
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} container justifyContent="center" alignItems="center">
                                        <Stack direction="row" maxHeight={65} marginTop={'30px'} marginLeft={'56px'}>
                                            <img src={(meuFormaPagamentoTipo == 1 ? pixIcon : pixIconDisabled)} onClick={(e) => TipoPagamento(1)} style={{ height: '50px', maxHeight: '50px', marginTop: '8px', cursor: 'pointer' }} />
                                            <img src={(meuFormaPagamentoTipo == 2 ? boletoIcon : boletoIconDisabled)} onClick={(e) => TipoPagamento(2)} style={{ height: '50px', maxHeight: '50px', marginLeft: '90px', marginTop: '8px', cursor: 'pointer', pointerEvents: "none" }} />
                                            <img src={(meuFormaPagamentoTipo == 3 ? cartoes_selecaoIcon : cartoes_selecaoIconDisabled)} onClick={(e) => TipoPagamento(3)} sx={{ height: '45px', maxHeight: '45px' }} style={{ cursor: 'pointer', marginLeft: '30px' }} />
                                        </Stack>
                                    </Grid>

                                    <Grid item xs={12} container justifyContent="center" alignItems="center">

                                        {/* RESUMO PEDIDO INÍCIO */}

                                        <MuiCard sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '120px', maxWidth: '550px', marginTop: '8px' }}>
                                            <CardContent>
                                                <Stack spacing={2} direction="row">
                                                    <Avatar
                                                        src={PagamentoIcon}
                                                        style={{ borderRadius: 0, height: '50px', width: 'auto' }}
                                                    />
                                                    <Stack direction="column">
                                                        <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                                            Resumo do Pagamento:
                                                        </Typography>
                                                        <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                            Selecionado: <span style={{ fontWeight: "bold", fontSize: "1.2em" }}> {(meuFormaPagamentoTipo == 1 ? "PIX" : (meuFormaPagamentoTipo == 2 ? "BOLETO" : (meuFormaPagamentoTipo == 3 ? "CARTÃO" : "")))} </span>
                                                        </Typography>
                                                        <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />

                                                        <Grid container spacing={1}>
                                                            <Grid item xs={4} style={{ display: 'flex', fontSize: '18px' }}>
                                                                Sub-Total R$
                                                            </Grid>
                                                            <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', justifyContent: 'right', textAlign: 'right' }}>
                                                                {totalProdutos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                            </Grid>
                                                            <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}></Grid>

                                                            {totalDescontos > 0.00
                                                                ?
                                                                <>
                                                                    <Grid item xs={4} style={{ display: 'flex', fontSize: '18px' }}>
                                                                        Descontos R$
                                                                    </Grid>
                                                                    <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', justifyContent: 'right', textAlign: 'right', color: '#ff0000' }}>
                                                                        {totalDescontos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                                    </Grid>
                                                                    <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}></Grid>
                                                                </>
                                                                :
                                                                <></>
                                                            }

                                                            {totalCreditos > 0.00
                                                                ?
                                                                <>
                                                                    <Grid item xs={4} style={{ display: 'flex', fontSize: '18px' }}>
                                                                        Créditos R$
                                                                    </Grid>
                                                                    <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', justifyContent: 'right', textAlign: 'right', color: '#ff0000' }}>
                                                                        {totalCreditos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                                    </Grid>
                                                                    <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}></Grid>
                                                                </>
                                                                :
                                                                <></>
                                                            }

                                                            <Grid item xs={4} style={{ display: 'flex', fontSize: '18px' }}>
                                                                Frete R$
                                                            </Grid>
                                                            <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', justifyContent: 'right', textAlign: 'right' }}>
                                                                {totalFrete.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                            </Grid>
                                                            <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}></Grid>

                                                            <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', fontWeight: 'bold' }}>
                                                                Total R$
                                                            </Grid>
                                                            <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', fontWeight: 'bold', justifyContent: 'right', textAlign: 'right' }}>
                                                                {totalGeral.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                            </Grid>

                                                            <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                <Divider orientation="horizontal" flexItem sx={{ marginTop: '5px', marginBottom: '5px' }} />
                                                            </Grid>

                                                            {

                                                                meuFormaPagamentoTipo < 3 ? <></> : <>

                                                                    <Grid item xs={7} style={{ display: 'flex', fontSize: '18px', textAlign: 'left', bgcolor: '#ccc', alignItems: 'flex-end' }}>
                                                                        <FormControl>
                                                                            <FormLabel id="demo-row-radio-buttons-group-label">Tipo de Cartão</FormLabel>
                                                                            <RadioGroup
                                                                                row
                                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                                name="row-radio-buttons-group"
                                                                            >
                                                                                <FormControlLabel value="CCredito" checked={cartaoTipoCartao === 0} onChange={(e) => TelaTipoDeCartaoCreditoOuDebito(0)} control={<Radio />} label="Crédito" />
                                                                                <FormControlLabel value="CDebito" checked={cartaoTipoCartao === 1} disabled={true} onChange={(e) => TelaTipoDeCartaoCreditoOuDebito(1)} control={<Radio />} label="Débito" />
                                                                            </RadioGroup>
                                                                        </FormControl>
                                                                    </Grid>

                                                                    {cartaoSolicitarCPF_CNPJ ?
                                                                        <Grid item xs={7} style={{ display: 'flex', fontSize: '18px', textAlign: 'right', bgcolor: '#ccc', alignItems: 'flex-end' }}>
                                                                            <TextField id="cartaoCPF" name="cartaoCPF"
                                                                                onKeyUp={(event) => {
                                                                                    PesquisarCPF_CNPJ(event.target.value, event)
                                                                                }}
                                                                                inputProps={{ maxLength: 18 }}
                                                                                label="CPF/CNPJ do Portador" variant="outlined" size="small"
                                                                                defaultValue={"021.231.407-67"}
                                                                            />
                                                                        </Grid>
                                                                        : <></>}

                                                                    <Grid item xs={5} style={{ display: 'flex', alignContent: 'left' }}>
                                                                        <Box display={'flex'} alignContent={'center'} height={'70px'} width={'auto'} >
                                                                            <img src={(cartaoSelecionado == null || cartaoSelecionado == "" ? cartoes_CVV : (cartaoSelecionado == 'VISA' ? cartoes_VISA : (cartaoSelecionado == 'MASTERCARD' ? cartoes_MASTERCARD : (cartaoSelecionado == 'AMEX' ? cartoes_AMEX :
                                                                                (cartaoSelecionado == 'DINERS' ? cartoes_DINERS : (cartaoSelecionado == 'ELO' ? cartoes_ELO : (cartaoSelecionado == 'HIPERCARD' ? cartoes_HIPERCARD : (cartaoSelecionado == 'HIPER' ? cartoes_HIPER : (cartaoSelecionado == 'CABAL' ? cartoes_CABAL : cartoes_CVV)))))))))} alt={cartaoSelecionado} />
                                                                        </Box>
                                                                    </Grid>

                                                                    <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                            {cpf_cnpjError}
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <TextField id="cartaoNumero" name="cartaoNumero" fullWidth defaultValue={""} onKeyUp={(event) => {
                                                                            TestarNumeroCartaoCredito(event.target.value, event)
                                                                        }} inputProps={{ maxLength: 19 }} label="Número do Cartão" variant="outlined" size="small" />
                                                                    </Grid>

                                                                    <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                            {cartaoNumeroError}
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <TextField id="cartaoNome" name="cartaoNome" fullWidth inputProps={{ maxLength: 100 }} label="Nome Completo Como Está no Cartão" onKeyUp={(event) => {
                                                                            TestarNomeCartao(event.target.value, event)
                                                                        }} variant="outlined" size="small"
                                                                            defaultValue={""}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                            {cartaoNomeError}
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={5} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <TextField id="cartaoValidade" name="cartaoValidade"
                                                                            onKeyUp={(event) => {
                                                                                TestarValidadeCartaoCredito(event.target.value, event)
                                                                            }} inputProps={{ maxLength: 5 }} label="Validade MM/AA" variant="outlined" size="small" sx={{ marginTop: "8px" }}
                                                                            defaultValue={""}
                                                                        />
                                                                    </Grid>

                                                                    <Grid item xs={7} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <TextField id="cartaoCVV" name="cartaoCVV" onKeyUp={(event) => {
                                                                            TestarCVV(event.target.value, event)
                                                                        }} inputProps={{ maxLength: 4 }} label="CVV Código de Segurança" variant="outlined" size="small" sx={{ marginTop: "8px", marginLeft: '10px' }} fullWidth
                                                                            defaultValue={""}
                                                                        />
                                                                    </Grid>

                                                                    <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                            {vencimentoError}
                                                                        </Typography>
                                                                    </Grid>

                                                                    {cartaoSolicitarCPF_CNPJ ?
                                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                            <FormControl fullWidth>
                                                                                <InputLabel id="opcao_parcelamentos-label">Parcelamentos</InputLabel>
                                                                                <Select
                                                                                    labelId="opcao_parcelamentos-label"
                                                                                    id="opcao_parcelamentos"
                                                                                    // multiple                                                                                                                
                                                                                    value={pagamentoOpcaoSelecionada}
                                                                                    onChange={handleChangeComboParcelamentos}
                                                                                    input={<OutlinedInput label="Opção de Parcelamento" />}
                                                                                    //renderValue={(selected) => selected.join(', ')}
                                                                                    renderValue={(selected) => selected}
                                                                                    MenuProps={MenuProps}
                                                                                >
                                                                                    {pagamentoValorParcelas != undefined && pagamentoValorParcelas.map((parcela) => (
                                                                                        <MenuItem key={parcela} value={parcela}>
                                                                                            <Checkbox />
                                                                                            <ListItemText primary={parcela} />
                                                                                        </MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                            </FormControl>
                                                                        </Grid>
                                                                        : <></>}

                                                                    <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                            {pagamentoNumeroParcelasError}
                                                                        </Typography>
                                                                    </Grid>
                                                                </>
                                                            }

                                                            <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                    {confirmouCancelamentoError}
                                                                </Typography>
                                                            </Grid>


                                                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex', alignContent: 'left', textAlign: 'left' }}>
                                                                {sumirBotao
                                                                    ?
                                                                    <></>
                                                                    :                                                                                                                                     
                                                                    <FormGroup>
                                                                        <FormControlLabel control={<Checkbox color="error" defaultValue={confirmouCancelamento} onChange={(e) => handleCheckBoxConcordo(e)} />}
                                                                            label={<Typography color="error">Concordo Caso Falte Algum Item Cancelamento Parcial ou Total (Entraremos em Contato)
                                                                            </Typography>}
                                                                        />
                                                                        <Typography align='left'>
                                                                            <Link
                                                                                component="button"
                                                                                variant="body2"
                                                                                onClick={() => { setOpenQuestion(true); }}><img src={Question} alt="Duvidas" style={{ width: '20px', height: 'auto' }} />
                                                                            </Link>
                                                                        </Typography>
                                                                    </FormGroup>
                                                                }
                                                            </Grid>

                                                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', textAlign: 'center' }}>
                                                                {sumirBotao
                                                                    ?
                                                                    <></>
                                                                    :
                                                                    <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', minWidth: '200px' }} onClick={(e) => salvarDadosPagamento(e)}>Finalizar Pagamento</Button>
                                                                }
                                                                {!fechandoPedido
                                                                    ?
                                                                    <></>
                                                                    :
                                                                    <Box minHeight={'352px'} justifyContent={'center'} textAlign={'center'}  marginTop={'110px'}>
                                                                    <CircularProgress color="success">Aguarde...</CircularProgress>
                                                                    </Box>
                                                                }
                                                            </Grid>

                                                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', textAlign: 'center' }}>
                                                                <Typography color="error">{falhouPagamentos}</Typography>
                                                            </Grid>

                                                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', textAlign: 'center' }}>
                                                                <div ref={qrCodeRef}></div>
                                                            </Grid>

                                                            {sumirBotao
                                                                ?
                                                                <>
                                                                    <Grid item xs={6} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', textAlign: 'center' }}>
                                                                        <Button variant="contained" onClick={() => handleEnviarMensagemWhatsApp()} style={{ backgroundColor: '#357a38', maxHeight: '30px', marginTop: '10px' }}>Compartilhar</Button>
                                                                    </Grid>
                                                                    <Grid item xs={6} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', textAlign: 'center' }}>
                                                                        {/* <Button variant="contained" onClick={() => handleSendMensagemWhatsApp(1)} disabled={showModalMeuTelefone} style={{ backgroundColor: '#357a38', maxHeight: '30px', marginTop: '10px' }}>Compartilhar</Button> */}
                                                                        <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '30px', marginTop: '10px' }} onClick={() => functionCopyToClipboard(urlQRCode ?? "")}>Copia e Cola</Button>
                                                                    </Grid>
                                                                </>
                                                                :
                                                                <></>
                                                            }




                                                            {(showModalMeuTelefone
                                                                ?
                                                                <Grid container justifyContent={"center"} spacing={2} marginTop={'0'}>
                                                                    <Grid item xs={12}>
                                                                        <div marginLeft="15px">
                                                                            <Typography sx={{ fontSize: "16px", marginLeft: "15px" }}><strong>Compartilhar via WhatsApp</strong></Typography>
                                                                            <Typography sx={{ fontSize: "12px", marginLeft: "15px" }}>Digite o Número do Telefone com WhatsApp:</Typography>
                                                                            <Box marginLeft={"15px"}>
                                                                                <InputMask
                                                                                    marginTop="5px"
                                                                                    mask="(99) 99999-9999"
                                                                                    value={phoneNumber}
                                                                                    onChange={handleInputChange}
                                                                                    placeholder="(99) 99999-9999"
                                                                                />
                                                                                <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '30px', marginLeft: '10px' }} onClick={handleEnviarWhatsAppWeb} disabled={phoneNumber.replace(/\D/g, '').length !== 11}>Enviar Mensagem</Button>
                                                                            </Box>
                                                                        </div>
                                                                    </Grid>
                                                                </Grid>
                                                                :
                                                                <></>
                                                            )}



                                                        </Grid>

                                                    </Stack>
                                                </Stack>
                                            </CardContent>

                                        </MuiCard>

                                        {/* RESUMO PEDIDO FINAL */}
                                    </Grid>

                                </Grid>
                            </CardContent>
                        </MuiCard>

                        :
                        
                        <Box minHeight={'350px'} justifyContent={'center'} textAlign={'center'}  marginTop={'110px'}>Aguarde...</Box>   

                    )}
                </>

                {
                        (openQuestion ?
                            <div>
                                <Modal
                                    aria-labelledby="transition-modal-title"
                                    aria-describedby="transition-modal-description"
                                    open={openQuestion}
                                    onClose={handleCloseModalQuestion}
                                    closeAfterTransition
                                    BackdropComponent={Backdrop}
                                    BackdropProps={{
                                        timeout: 500,
                                    }}
                                >
                                    <Fade in={openQuestion}>
                                        {/* <Box sx={modalStyle}>
                                            <Typography>AAAA BBBB CCCC</Typography>
                                        </Box> */}
                                        <Box sx={modalStyleQuestions}>
                                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                                Porque Aceitar Devolução Total ou Parcial?
                                            </Typography>
                                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                                Nosso estoque disponível para vendas somente é reservado após a finalização do pagamento isso poderia ocasionar a falta de algum produto ainda sem a reserva concluída.
                                            </Typography>
                                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                                Caso isso ocorra entraremos em contato para que você decida o que deseja fazer com o seu pedido.
                                            </Typography>
                                        </Box>
                                    </Fade>
                                </Modal>
                            </div>
                            :
                            <div></div>)
                    }
            </BrowserView>

            <MobileView>
                <>
                    {(vendaEfetuada != null
                        ?

                        <MuiCard sx={{ bgcolor: '#F5F5F5', marginLeft: '10px', marginTop: '10px', marginRight: '10px', minHeight: '10px', marginBottom: '10px' }}>
                            <CardContent>

                                <Grid container marginTop={'30px'}>
                                    <Grid item xs={12} container justifyContent="flex-start">
                                        <Typography sx={{ fontSize: "14px" }} style={{ color: 'black' }}>
                                            Link de Pagamento:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} container justifyContent="flex-start">
                                        <Typography sx={{ fontSize: "16px", fontWeight: "bold" }} style={{ color: 'black', fontWeight: 'bold' }}>
                                            {(vendaEfetuada != null ? maskString(vendaEfetuada?.preVendas.cliente_razao_social, 10) : "")}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} container justifyContent="flex-start">
                                        <Typography variant='h16' style={{ color: 'black' }}>
                                            Valor R$:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} container justifyContent="flex-end">
                                        <Typography sx={{ fontSize: "16px", fontWeight: "bold", marginRight: '30px' }} style={{ color: 'black' }}>
                                            {(vendaEfetuada != null ? numberWithCommas(vendaEfetuada?.preVendas.total_geral) : "")}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6} container justifyContent="flex-start">
                                        <Typography sx={{ fontSize: "14px" }} style={{ color: 'black' }}>
                                            Pré-Venda:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} container justifyContent="flex-end">
                                        <Typography sx={{ fontSize: "16px", fontWeight: "bold", marginRight: '30px' }} style={{ color: 'black', fontWeight: 'bold' }}>
                                            {_preVendaId + "-" + _preVendaIdLoja}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} container justifyContent="flex-start">
                                        <Typography variant='h16' style={{ color: 'black' }}>
                                            Expira em:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8} container justifyContent="flex-end">
                                        <Typography sx={{ fontSize: "16px", fontWeight: "bold", marginRight: '30px' }} style={{ color: 'black', fontWeight: 'bold' }}>
                                            {formatarDataHora(_expiraEm, 4)}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} container justifyContent="center" alignItems="center">
                                        <Typography sx={{ fontSize: "12px", marginTop: '25px' }} style={{ color: 'grey' }}>
                                            Selecione Abaixo o Meio de Pagamento Desejado Para Continuar
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} container justifyContent="center" alignItems="center">
                                        <Stack direction="column" marginTop={'15px'} marginBottom={'15px'} spacing={4}>
                                            <img src={(meuFormaPagamentoTipo == 1 ? pixIcon : pixIconDisabled)} onClick={(e) => TipoPagamento(1)} style={{ height: '45px', maxHeight: '45px', marginTop: '8px', cursor: 'pointer' }} />
                                            <img src={(meuFormaPagamentoTipo == 2 ? boletoIcon : boletoIconDisabled)} onClick={(e) => TipoPagamento(2)} style={{ height: '60px', maxHeight: '60px', marginTop: '25px', cursor: 'pointer', pointerEvents: "none" }} />
                                            <img src={(meuFormaPagamentoTipo == 3 ? cartoes_selecaoIcon : cartoes_selecaoIconDisabled)} onClick={(e) => TipoPagamento(3)} sx={{ height: '70px', maxHeight: '70px', marginTop: '25px' }} style={{ cursor: 'pointer', maxWidth: "100%", maxHeight: "70px" }} />
                                        </Stack>
                                    </Grid>

                                    <Grid item xs={12} container justifyContent="center" alignItems="center">

                                        {/* RESUMO PEDIDO INÍCIO */}

                                        <MuiCard sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '120px', maxWidth: '550px', marginTop: '8px' }}>
                                            <CardContent>
                                                <Stack spacing={2} direction="row">
                                                    <Avatar
                                                        src={PagamentoIcon}
                                                        style={{ borderRadius: 0, height: '50px', width: 'auto' }}
                                                    />
                                                    <Stack direction="column">
                                                        <Typography variant="h10" color="text.primary" textAlign={"left"}>
                                                            Resumo do Pagamento:
                                                        </Typography>
                                                        <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                            Selecionado: <span style={{ fontWeight: "bold", fontSize: "1.2em" }}> {(meuFormaPagamentoTipo == 1 ? "PIX" : (meuFormaPagamentoTipo == 2 ? "BOLETO" : (meuFormaPagamentoTipo == 3 ? "CARTÃO" : "")))} </span>
                                                        </Typography>
                                                        <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />

                                                        <Grid container spacing={1}>
                                                            <Grid item xs={5} style={{ display: 'flex', fontSize: '14px' }}>
                                                                Sub-Total R$
                                                            </Grid>
                                                            <Grid item xs={7} style={{ display: 'flex', fontSize: '14px', justifyContent: 'right', textAlign: 'right' }}>
                                                                {totalProdutos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                            </Grid>


                                                            {totalDescontos > 0.00
                                                                ?
                                                                <>
                                                                    <Grid item xs={5} style={{ display: 'flex', fontSize: '14px' }}>
                                                                        Descontos R$
                                                                    </Grid>
                                                                    <Grid item xs={7} style={{ display: 'flex', fontSize: '14px', justifyContent: 'right', textAlign: 'right', color: '#ff0000' }}>
                                                                        {totalDescontos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                                    </Grid>
                                                                </>
                                                                :
                                                                <></>
                                                            }

                                                            {totalCreditos > 0.00
                                                                ?
                                                                <>
                                                                    <Grid item xs={5} style={{ display: 'flex', fontSize: '14px' }}>
                                                                        Créditos R$
                                                                    </Grid>
                                                                    <Grid item xs={7} style={{ display: 'flex', fontSize: '14px', justifyContent: 'right', textAlign: 'right', color: '#ff0000' }}>
                                                                        {totalCreditos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                                    </Grid>
                                                                </>
                                                                :
                                                                <></>
                                                            }

                                                            <Grid item xs={5} style={{ display: 'flex', fontSize: '14px' }}>
                                                                Frete R$
                                                            </Grid>
                                                            <Grid item xs={7} style={{ display: 'flex', fontSize: '14px', justifyContent: 'right', textAlign: 'right' }}>
                                                                {totalFrete.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                            </Grid>


                                                            <Grid item xs={5} style={{ display: 'flex', fontSize: '14px', fontWeight: 'bold' }}>
                                                                Total R$
                                                            </Grid>
                                                            <Grid item xs={7} style={{ display: 'flex', fontSize: '14px', fontWeight: 'bold', justifyContent: 'right', textAlign: 'right' }}>
                                                                {totalGeral.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                            </Grid>

                                                            <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                <Divider orientation="horizontal" flexItem sx={{ marginTop: '5px', marginBottom: '5px' }} />
                                                            </Grid>

                                                            {

                                                                meuFormaPagamentoTipo < 3 ? <></> : <>

                                                                    <Grid item xs={7} style={{ display: 'flex', fontSize: '18px', textAlign: 'left', bgcolor: '#ccc', alignItems: 'flex-end' }}>
                                                                        <FormControl>
                                                                            <FormLabel id="demo-row-radio-buttons-group-label">Tipo de Cartão</FormLabel>
                                                                            <RadioGroup
                                                                                row
                                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                                name="row-radio-buttons-group"
                                                                            >
                                                                                <FormControlLabel value="CCredito" checked={cartaoTipoCartao === 0} onChange={(e) => TelaTipoDeCartaoCreditoOuDebito(0)} control={<Radio />} label="Crédito" />
                                                                                <FormControlLabel value="CDebito" checked={cartaoTipoCartao === 1} disabled={true} onChange={(e) => TelaTipoDeCartaoCreditoOuDebito(1)} control={<Radio />} label="Débito" />
                                                                            </RadioGroup>
                                                                        </FormControl>
                                                                    </Grid>

                                                                    {cartaoSolicitarCPF_CNPJ ?
                                                                        <Grid item xs={8.5} style={{ display: 'flex', fontSize: '18px', textAlign: 'right', bgcolor: '#ccc', alignItems: 'flex-end' }}>
                                                                            <TextField id="cartaoCPF" name="cartaoCPF"
                                                                                onKeyUp={(event) => {
                                                                                    PesquisarCPF_CNPJ(event.target.value, event)
                                                                                }}
                                                                                inputProps={{ maxLength: 18 }}
                                                                                label="CPF/CNPJ do Portador" variant="outlined" size="small"
                                                                                defaultValue={""}
                                                                            />
                                                                        </Grid>
                                                                        : <></>}

                                                                    <Grid item xs={3.5} style={{ display: 'flex', alignContent: 'left' }}>
                                                                        <Box display={'flex'} alignContent={'center'} height={'45px'} width={'auto'} >
                                                                            <img src={(cartaoSelecionado == null || cartaoSelecionado == "" ? cartoes_CVV : (cartaoSelecionado == 'VISA' ? cartoes_VISA : (cartaoSelecionado == 'MASTERCARD' ? cartoes_MASTERCARD : (cartaoSelecionado == 'AMEX' ? cartoes_AMEX :
                                                                                (cartaoSelecionado == 'DINERS' ? cartoes_DINERS : (cartaoSelecionado == 'ELO' ? cartoes_ELO : (cartaoSelecionado == 'HIPERCARD' ? cartoes_HIPERCARD : (cartaoSelecionado == 'HIPER' ? cartoes_HIPER : (cartaoSelecionado == 'CABAL' ? cartoes_CABAL : cartoes_CVV)))))))))} alt={cartaoSelecionado} />
                                                                        </Box>
                                                                    </Grid>

                                                                    <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                            {cpf_cnpjError}
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <TextField id="cartaoNumero" name="cartaoNumero" fullWidth defaultValue={""} onKeyUp={(event) => {
                                                                            TestarNumeroCartaoCredito(event.target.value, event)
                                                                        }} inputProps={{ maxLength: 19 }} label="Número do Cartão" variant="outlined" size="small" />
                                                                    </Grid>

                                                                    <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                            {cartaoNumeroError}
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <TextField id="cartaoNome" name="cartaoNome" fullWidth inputProps={{ maxLength: 100 }} label="Nome Completo Como Está no Cartão" onKeyUp={(event) => {
                                                                            TestarNomeCartao(event.target.value, event)
                                                                        }} variant="outlined" size="small"
                                                                            defaultValue={""}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                            {cartaoNomeError}
                                                                        </Typography>
                                                                    </Grid>

                                                                    <Grid item xs={5} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <TextField id="cartaoValidade" name="cartaoValidade"
                                                                            onKeyUp={(event) => {
                                                                                TestarValidadeCartaoCredito(event.target.value, event)
                                                                            }} inputProps={{ maxLength: 5 }} label="Validade MM/AA" variant="outlined" size="small" sx={{ marginTop: "8px" }}
                                                                            defaultValue={""}
                                                                        />
                                                                    </Grid>

                                                                    <Grid item xs={7} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <TextField id="cartaoCVV" name="cartaoCVV" onKeyUp={(event) => {
                                                                            TestarCVV(event.target.value, event)
                                                                        }} inputProps={{ maxLength: 4 }} label="CVV Código de Segurança" variant="outlined" size="small" sx={{ marginTop: "8px", marginLeft: '10px' }} fullWidth
                                                                            defaultValue={""}
                                                                        />
                                                                    </Grid>

                                                                    <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                            {vencimentoError}
                                                                        </Typography>
                                                                    </Grid>

                                                                    {cartaoSolicitarCPF_CNPJ ?
                                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                            <FormControl fullWidth>
                                                                                <InputLabel id="opcao_parcelamentos-label">Parcelamentos</InputLabel>
                                                                                <Select
                                                                                    labelId="opcao_parcelamentos-label"
                                                                                    id="opcao_parcelamentos"
                                                                                    // multiple                                                                                                                
                                                                                    value={pagamentoOpcaoSelecionada}
                                                                                    onChange={handleChangeComboParcelamentos}
                                                                                    input={<OutlinedInput label="Opção de Parcelamento" />}
                                                                                    //renderValue={(selected) => selected.join(', ')}
                                                                                    renderValue={(selected) => selected}
                                                                                    MenuProps={MenuProps}
                                                                                >
                                                                                    {pagamentoValorParcelas != undefined && pagamentoValorParcelas.map((parcela) => (
                                                                                        <MenuItem key={parcela} value={parcela}>
                                                                                            <Checkbox />
                                                                                            <ListItemText primary={parcela} />
                                                                                        </MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                            </FormControl>
                                                                        </Grid>
                                                                        : <></>}

                                                                    <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                        <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                            {pagamentoNumeroParcelasError}
                                                                        </Typography>
                                                                    </Grid>
                                                                </>
                                                            }

                                                            <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                    {confirmouCancelamentoError}
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex', alignContent: 'left', textAlign: 'left' }}>
                                                                {sumirBotao
                                                                    ?
                                                                    <></>
                                                                    :
                                                                    <FormGroup>
                                                                        <FormControlLabel control={<Checkbox color="error" defaultValue={confirmouCancelamento} onChange={(e) => handleCheckBoxConcordo(e)} />}
                                                                            label={<Typography color="error">Concordo Caso Falte Algum Item Cancelamento Parcial ou Total (Entraremos em Contato)
                                                                            </Typography>}
                                                                        />
                                                                        <Typography align='left'>
                                                                            <Link
                                                                                component="button"
                                                                                variant="body2"
                                                                                onClick={() => { setOpenQuestion(true); }}><img src={Question} alt="Duvidas" style={{ width: '20px', height: 'auto' }} />
                                                                            </Link>
                                                                        </Typography>
                                                                    </FormGroup>
                                                                }
                                                            </Grid>

                                                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', textAlign: 'center' }}>
                                                                {sumirBotao
                                                                    ?
                                                                    <></>
                                                                    :
                                                                    <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', minWidth: '200px' }} onClick={(e) => salvarDadosPagamento(e)}>Finalizar Pagamento</Button>
                                                                }
                                                                {!fechandoPedido
                                                                    ?
                                                                    <></>
                                                                    :
                                                                    <Box minHeight={'220px'} justifyContent={'center'} textAlign={'center'}  marginTop={'110px'}>
                                                                    <CircularProgress color="success">Aguarde...</CircularProgress>
                                                                    </Box>
                                                                }
                                                            </Grid>

                                                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', textAlign: 'center' }}>
                                                                <Typography color="error">{falhouPagamentos}</Typography>
                                                            </Grid>

                                                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', textAlign: 'center' }}>
                                                                <div ref={qrCodeRef}></div>
                                                            </Grid>

                                                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', textAlign: 'center' }}>
                                                                {/* <Button variant="contained" onClick={() => handleCompartilharLinkPagamento()} style={{ backgroundColor: '#357a38', maxHeight: '30px', marginTop: '10px' }}>Compartilhar</Button> */}
                                                                <Button variant="contained" onClick={() => handleSendMensagemWhatsApp(1)} disabled={showModalMeuTelefone} style={{ backgroundColor: '#357a38', maxHeight: '30px', marginTop: '10px' }}>Compartilhar</Button>
                                                            </Grid>
                                                            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', textAlign: 'center' }}>
                                                                <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '30px', marginTop: '10px' }} onClick={() => functionCopyToClipboard(urlQRCode ?? "")}>Copia e Cola</Button>
                                                            </Grid>
                                                        </Grid>

                                                    </Stack>
                                                </Stack>
                                            </CardContent>

                                        </MuiCard>

                                        {/* RESUMO PEDIDO FINAL */}
                                    </Grid>

                                </Grid>
                            </CardContent>
                        </MuiCard>

                        :

                        <Box minHeight={'220px'} justifyContent={'center'} textAlign={'center'}  marginTop={'110px'}>Aguarde...</Box>

                    )}
                </>

                {
                        (openQuestion ?
                            <div>
                                <Modal
                                    aria-labelledby="transition-modal-title"
                                    aria-describedby="transition-modal-description"
                                    open={openQuestion}
                                    onClose={handleCloseModalQuestion}
                                    closeAfterTransition
                                    BackdropComponent={Backdrop}
                                    BackdropProps={{
                                        timeout: 500,
                                    }}
                                >
                                    <Fade in={openQuestion}>
                                        {/* <Box sx={modalStyle}>
                                            <Typography>AAAA BBBB CCCC</Typography>
                                        </Box> */}
                                        <Box sx={modalStyleQuestions}>
                                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                                Porque Aceitar Devolução Total ou Parcial?
                                            </Typography>
                                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                                Nosso estoque disponível para vendas somente é reservado somente após a finalização do pagamento isso poderia ocasionar a falta de algum produto ainda não concluído a sua reseva.
                                            </Typography>
                                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                                Caso isso ocorra entraremos em contato para que você decida o que deseja fazer com o seu pedido.
                                            </Typography>
                                        </Box>
                                    </Fade>
                                </Modal>
                            </div>
                            :
                            <div></div>)
                    }


            </MobileView>
        </>
    );
};
export default Card;
